import { ɵɵdefineInjectable, Injectable, Component, Inject, ɵɵinject, Input, NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import Bugsnag from '@bugsnag/js';
import { MatIconModule } from '@angular/material/icon';
import { MatSnackBar, MatSnackBarModule } from '@angular/material/snack-bar';
import { Validators, FormBuilder, FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatDialogRef, MAT_DIALOG_DATA, MatDialog, MatDialogModule } from '@angular/material/dialog';
import { MatButtonModule } from '@angular/material/button';
import { MatInputModule } from '@angular/material/input';
import { MatButtonToggleModule } from '@angular/material/button-toggle';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { MatTabsModule } from '@angular/material/tabs';
import { NgxExtendedPdfViewerModule } from 'ngx-extended-pdf-viewer';
import * as download_ from 'downloadjs';
import { HttpHeaders, HttpClient } from '@angular/common/http';
import { BehaviorSubject, throwError, Subject, Observable } from 'rxjs';
import { catchError, tap } from 'rxjs/operators';
import { KeycloakService, KeycloakAuthGuard } from 'keycloak-angular';
import { I18n } from '@ngx-translate/i18n-polyfill';
import { MatListModule } from '@angular/material/list';
import { Router, ActivatedRoute } from '@angular/router';
import { __awaiter } from 'tslib';

import * as ɵngcc0 from '@angular/core';
import * as ɵngcc1 from '@angular/common/http';
import * as ɵngcc2 from '@angular/common';
import * as ɵngcc3 from '@angular/material/snack-bar';
import * as ɵngcc4 from '@angular/material/icon';
import * as ɵngcc5 from 'keycloak-angular';
import * as ɵngcc6 from '@angular/material/dialog';
import * as ɵngcc7 from 'ngx-extended-pdf-viewer';
import * as ɵngcc8 from '@ngx-translate/i18n-polyfill';
import * as ɵngcc9 from '@angular/forms';
import * as ɵngcc10 from '@angular/material/button';
import * as ɵngcc11 from '@angular/material/form-field';
import * as ɵngcc12 from '@angular/material/input';
import * as ɵngcc13 from '@angular/router';
import * as ɵngcc14 from '@angular/material/progress-spinner';
import * as ɵngcc15 from '@angular/material/tabs';
import * as ɵngcc16 from '@angular/material/list';
import * as ɵngcc17 from '@angular/material/core';

function MessagesComponent_div_0_mat_icon_1_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "mat-icon", 5);
    ɵngcc0.ɵɵtext(1, "info");
    ɵngcc0.ɵɵelementEnd();
} }
function MessagesComponent_div_0_mat_icon_2_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "mat-icon", 5);
    ɵngcc0.ɵɵtext(1, "check");
    ɵngcc0.ɵɵelementEnd();
} }
function MessagesComponent_div_0_mat_icon_3_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "mat-icon", 5);
    ɵngcc0.ɵɵtext(1, "warning");
    ɵngcc0.ɵɵelementEnd();
} }
function MessagesComponent_div_0_mat_icon_4_Template(rf, ctx) { if (rf & 1) {
    const _r6 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "mat-icon", 6);
    ɵngcc0.ɵɵlistener("click", function MessagesComponent_div_0_mat_icon_4_Template_mat_icon_click_0_listener() { ɵngcc0.ɵɵrestoreView(_r6); const ctx_r5 = ɵngcc0.ɵɵnextContext(2); return ctx_r5.closeMsg(); });
    ɵngcc0.ɵɵtext(1, "close");
    ɵngcc0.ɵɵelementEnd();
} }
const _c0 = function (a0, a1, a2, a3) { return { "validation-message--error": a0, "validation-message--success": a1, "validation-message--size-large": a2, "validation-message--full-width": a3 }; };
function MessagesComponent_div_0_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "div", 1);
    ɵngcc0.ɵɵtemplate(1, MessagesComponent_div_0_mat_icon_1_Template, 2, 0, "mat-icon", 2);
    ɵngcc0.ɵɵtemplate(2, MessagesComponent_div_0_mat_icon_2_Template, 2, 0, "mat-icon", 2);
    ɵngcc0.ɵɵtemplate(3, MessagesComponent_div_0_mat_icon_3_Template, 2, 0, "mat-icon", 2);
    ɵngcc0.ɵɵtemplate(4, MessagesComponent_div_0_mat_icon_4_Template, 2, 0, "mat-icon", 3);
    ɵngcc0.ɵɵelementStart(5, "div", 4);
    ɵngcc0.ɵɵelementStart(6, "h5");
    ɵngcc0.ɵɵtext(7);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(8, "p");
    ɵngcc0.ɵɵtext(9);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r0 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵclassMapInterpolate1("validation-message ", ctx_r0.boxClass, "");
    ɵngcc0.ɵɵproperty("ngClass", ɵngcc0.ɵɵpureFunction4(10, _c0, ctx_r0.type === "error", ctx_r0.type === "success", ctx_r0.size === "large", ctx_r0.width === "full"));
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngIf", ctx_r0.type === "info");
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngIf", ctx_r0.type === "check");
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngIf", ctx_r0.type === "warning");
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngIf", ctx_r0.type === "warning");
    ɵngcc0.ɵɵadvance(3);
    ɵngcc0.ɵɵtextInterpolate1(" ", ctx_r0.message.title, " ");
    ɵngcc0.ɵɵadvance(2);
    ɵngcc0.ɵɵtextInterpolate1(" ", ctx_r0.message.detail, " ");
} }
function PdfViewDialogComponent_span_5_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "span", 9);
    ɵngcc0.ɵɵelementStart(1, "mat-icon", 10);
    ɵngcc0.ɵɵtext(2, "done");
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(3, "span");
    ɵngcc0.ɵɵi18n(4, 11);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
} }
function AcceptOfferDialogComponent_ng_container_3_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementContainerStart(0);
    ɵngcc0.ɵɵelementStart(1, "header", 7);
    ɵngcc0.ɵɵelementStart(2, "h4", 8);
    ɵngcc0.ɵɵelementStart(3, "span");
    ɵngcc0.ɵɵi18n(4, 9);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(5, "p");
    ɵngcc0.ɵɵelementStart(6, "span");
    ɵngcc0.ɵɵi18n(7, 10);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const ctx_r0 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵadvance(7);
    ɵngcc0.ɵɵi18nExp(ctx_r0.data.clientName);
    ɵngcc0.ɵɵi18nApply(7);
} }
function AcceptOfferDialogComponent_ng_container_4_mat_error_6_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "mat-error");
    ɵngcc0.ɵɵi18n(1, 22);
    ɵngcc0.ɵɵelementEnd();
} }
function AcceptOfferDialogComponent_ng_container_4_mat_error_7_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "mat-error");
    ɵngcc0.ɵɵi18n(1, 23);
    ɵngcc0.ɵɵelementEnd();
} }
function AcceptOfferDialogComponent_ng_container_4_mat_error_12_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "mat-error");
    ɵngcc0.ɵɵi18n(1, 24);
    ɵngcc0.ɵɵelementEnd();
} }
function AcceptOfferDialogComponent_ng_container_4_mat_error_13_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "mat-error");
    ɵngcc0.ɵɵi18n(1, 25);
    ɵngcc0.ɵɵelementEnd();
} }
function AcceptOfferDialogComponent_ng_container_4_mat_error_18_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "mat-error");
    ɵngcc0.ɵɵi18n(1, 26);
    ɵngcc0.ɵɵelementEnd();
} }
function AcceptOfferDialogComponent_ng_container_4_mat_error_19_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "mat-error");
    ɵngcc0.ɵɵi18n(1, 27);
    ɵngcc0.ɵɵelementEnd();
} }
function AcceptOfferDialogComponent_ng_container_4_mat_error_24_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "mat-error");
    ɵngcc0.ɵɵi18n(1, 28);
    ɵngcc0.ɵɵelementEnd();
} }
function AcceptOfferDialogComponent_ng_container_4_mat_error_25_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "mat-error");
    ɵngcc0.ɵɵi18n(1, 29);
    ɵngcc0.ɵɵelementEnd();
} }
function AcceptOfferDialogComponent_ng_container_4_Template(rf, ctx) { if (rf & 1) {
    const _r12 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementContainerStart(0);
    ɵngcc0.ɵɵelementStart(1, "form", 11);
    ɵngcc0.ɵɵlistener("ngSubmit", function AcceptOfferDialogComponent_ng_container_4_Template_form_ngSubmit_1_listener() { ɵngcc0.ɵɵrestoreView(_r12); const ctx_r11 = ɵngcc0.ɵɵnextContext(); return ctx_r11.acceptOffer(ctx_r11.acceptOfferForm); });
    ɵngcc0.ɵɵelementStart(2, "mat-form-field", 12);
    ɵngcc0.ɵɵelementStart(3, "mat-label");
    ɵngcc0.ɵɵi18n(4, 13);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelement(5, "input", 14);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵtemplate(6, AcceptOfferDialogComponent_ng_container_4_mat_error_6_Template, 2, 0, "mat-error", 2);
    ɵngcc0.ɵɵtemplate(7, AcceptOfferDialogComponent_ng_container_4_mat_error_7_Template, 2, 0, "mat-error", 2);
    ɵngcc0.ɵɵelementStart(8, "mat-form-field", 15);
    ɵngcc0.ɵɵelementStart(9, "mat-label");
    ɵngcc0.ɵɵi18n(10, 16);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelement(11, "input", 17);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵtemplate(12, AcceptOfferDialogComponent_ng_container_4_mat_error_12_Template, 2, 0, "mat-error", 2);
    ɵngcc0.ɵɵtemplate(13, AcceptOfferDialogComponent_ng_container_4_mat_error_13_Template, 2, 0, "mat-error", 2);
    ɵngcc0.ɵɵelementStart(14, "mat-form-field", 15);
    ɵngcc0.ɵɵelementStart(15, "mat-label");
    ɵngcc0.ɵɵi18n(16, 18);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelement(17, "input", 19);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵtemplate(18, AcceptOfferDialogComponent_ng_container_4_mat_error_18_Template, 2, 0, "mat-error", 2);
    ɵngcc0.ɵɵtemplate(19, AcceptOfferDialogComponent_ng_container_4_mat_error_19_Template, 2, 0, "mat-error", 2);
    ɵngcc0.ɵɵelementStart(20, "mat-form-field", 15);
    ɵngcc0.ɵɵelementStart(21, "mat-label");
    ɵngcc0.ɵɵi18n(22, 20);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelement(23, "input", 21);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵtemplate(24, AcceptOfferDialogComponent_ng_container_4_mat_error_24_Template, 2, 0, "mat-error", 2);
    ɵngcc0.ɵɵtemplate(25, AcceptOfferDialogComponent_ng_container_4_mat_error_25_Template, 2, 0, "mat-error", 2);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const ctx_r1 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("formGroup", ctx_r1.acceptOfferForm);
    ɵngcc0.ɵɵadvance(5);
    ɵngcc0.ɵɵproperty("ngIf", ctx_r1.acceptOfferForm.controls["name"].touched && ctx_r1.acceptOfferForm.controls["name"].hasError("required"));
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngIf", ctx_r1.acceptOfferForm.controls["name"].touched && ctx_r1.acceptOfferForm.controls["name"].hasError("pattern"));
    ɵngcc0.ɵɵadvance(5);
    ɵngcc0.ɵɵproperty("ngIf", ctx_r1.acceptOfferForm.controls["email"].touched && ctx_r1.acceptOfferForm.controls["email"].hasError("required"));
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngIf", ctx_r1.acceptOfferForm.controls["email"].touched && ctx_r1.acceptOfferForm.controls["email"].hasError("pattern"));
    ɵngcc0.ɵɵadvance(5);
    ɵngcc0.ɵɵproperty("ngIf", ctx_r1.acceptOfferForm.controls["ssn"].touched && ctx_r1.acceptOfferForm.controls["ssn"].hasError("required"));
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngIf", ctx_r1.acceptOfferForm.controls["ssn"].touched && ctx_r1.acceptOfferForm.controls["ssn"].hasError("pattern"));
    ɵngcc0.ɵɵadvance(5);
    ɵngcc0.ɵɵproperty("ngIf", ctx_r1.acceptOfferForm.controls["phone"].touched && ctx_r1.acceptOfferForm.controls["phone"].hasError("required"));
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngIf", ctx_r1.acceptOfferForm.controls["phone"].touched && ctx_r1.acceptOfferForm.controls["phone"].hasError("pattern"));
} }
function AcceptOfferDialogComponent_button_8_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "button", 30);
    ɵngcc0.ɵɵi18n(1, 31);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r2 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵproperty("disabled", ctx_r2.acceptOfferForm.invalid || ctx_r2.successDataLoader);
} }
const _c43 = function (a0) { return { "mr-5": a0 }; };
function OfferViewComponent_div_0_ngx_extended_pdf_viewer_2_Template(rf, ctx) { if (rf & 1) {
    const _r3 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "ngx-extended-pdf-viewer", 10);
    ɵngcc0.ɵɵlistener("pdfLoaded", function OfferViewComponent_div_0_ngx_extended_pdf_viewer_2_Template_ngx_extended_pdf_viewer_pdfLoaded_0_listener() { ɵngcc0.ɵɵrestoreView(_r3); const ctx_r2 = ɵngcc0.ɵɵnextContext(2); return ctx_r2.profileService.pdfViewerLoaded(); });
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r1 = ɵngcc0.ɵɵnextContext(2);
    ɵngcc0.ɵɵproperty("src", ctx_r1.offerData.documentUrl)("textLayer", false)("mobileFriendlyZoom", "150%")("maxZoom", 7)("enablePinchOnMobile", true)("handTool", false)("showToolbar", false)("backgroundColor", "#fff");
} }
function OfferViewComponent_div_0_Template(rf, ctx) { if (rf & 1) {
    const _r5 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "div", 1);
    ɵngcc0.ɵɵelementStart(1, "div", 2);
    ɵngcc0.ɵɵtemplate(2, OfferViewComponent_div_0_ngx_extended_pdf_viewer_2_Template, 1, 8, "ngx-extended-pdf-viewer", 3);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(3, "div", 4);
    ɵngcc0.ɵɵelementStart(4, "a", 5);
    ɵngcc0.ɵɵlistener("click", function OfferViewComponent_div_0_Template_a_click_4_listener() { ɵngcc0.ɵɵrestoreView(_r5); const ctx_r4 = ɵngcc0.ɵɵnextContext(); return ctx_r4.openFullSizeDialog(); });
    ɵngcc0.ɵɵelementStart(5, "mat-icon", 6);
    ɵngcc0.ɵɵtext(6, "crop_free");
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(7, "span");
    ɵngcc0.ɵɵi18n(8, 7);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(9, "a", 8);
    ɵngcc0.ɵɵlistener("click", function OfferViewComponent_div_0_Template_a_click_9_listener() { ɵngcc0.ɵɵrestoreView(_r5); const ctx_r6 = ɵngcc0.ɵɵnextContext(); return ctx_r6.profileService.downloadPdf(ctx_r6.offerData.documentUrl, ctx_r6.offerData.documentName); });
    ɵngcc0.ɵɵelementStart(10, "mat-icon", 6);
    ɵngcc0.ɵɵtext(11, "get_app");
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(12, "span");
    ɵngcc0.ɵɵi18n(13, 9);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r0 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵadvance(2);
    ɵngcc0.ɵɵproperty("ngIf", !ctx_r0.openFullScreen);
    ɵngcc0.ɵɵadvance(2);
    ɵngcc0.ɵɵproperty("ngClass", ctx_r0.config.brandConfig.styles.offerActionClass);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵclassMap("mr-1 " + ctx_r0.config.brandConfig.styles.actionIconsClass);
    ɵngcc0.ɵɵadvance(4);
    ɵngcc0.ɵɵproperty("ngClass", ctx_r0.config.brandConfig.styles.offerActionClass);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵclassMap("mr-1 " + ctx_r0.config.brandConfig.styles.actionIconsClass);
} }
function OfferActionsComponent_ng_container_0_div_5_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "div", 11);
    ɵngcc0.ɵɵi18n(1, 12);
    ɵngcc0.ɵɵelementEnd();
} }
function OfferActionsComponent_ng_container_0_mat_spinner_8_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelement(0, "mat-spinner", 13);
} }
function OfferActionsComponent_ng_container_0_mat_icon_9_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "mat-icon", 14);
    ɵngcc0.ɵɵtext(1, "done");
    ɵngcc0.ɵɵelementEnd();
} }
function OfferActionsComponent_ng_container_0_span_10_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "span");
    ɵngcc0.ɵɵi18n(1, 15);
    ɵngcc0.ɵɵelementEnd();
} }
function OfferActionsComponent_ng_container_0_span_11_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "span");
    ɵngcc0.ɵɵi18n(1, 16);
    ɵngcc0.ɵɵelementEnd();
} }
function OfferActionsComponent_ng_container_0_span_12_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "span");
    ɵngcc0.ɵɵi18n(1, 17);
    ɵngcc0.ɵɵelementEnd();
} }
function OfferActionsComponent_ng_container_0_a_13_mat_spinner_1_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelement(0, "mat-spinner", 13);
} }
const _c60 = function (a0) { return { "disabled": a0 }; };
function OfferActionsComponent_ng_container_0_a_13_Template(rf, ctx) { if (rf & 1) {
    const _r11 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "a", 18);
    ɵngcc0.ɵɵlistener("click", function OfferActionsComponent_ng_container_0_a_13_Template_a_click_0_listener() { ɵngcc0.ɵɵrestoreView(_r11); const ctx_r10 = ɵngcc0.ɵɵnextContext(2); return ctx_r10.openDeclineOfferDialog(); });
    ɵngcc0.ɵɵtemplate(1, OfferActionsComponent_ng_container_0_a_13_mat_spinner_1_Template, 1, 0, "mat-spinner", 8);
    ɵngcc0.ɵɵelementStart(2, "span");
    ɵngcc0.ɵɵi18n(3, 19);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r8 = ɵngcc0.ɵɵnextContext(2);
    ɵngcc0.ɵɵproperty("ngClass", ɵngcc0.ɵɵpureFunction1(2, _c60, ctx_r8.offerAcceptStatusLoader || ctx_r8.offerDeclineStatusLoader || !ctx_r8.profileService.isPdfReaded));
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngIf", ctx_r8.offerDeclineStatusLoader);
} }
function OfferActionsComponent_ng_container_0_Template(rf, ctx) { if (rf & 1) {
    const _r13 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementContainerStart(0);
    ɵngcc0.ɵɵelementStart(1, "button", 3);
    ɵngcc0.ɵɵlistener("click", function OfferActionsComponent_ng_container_0_Template_button_click_1_listener() { ɵngcc0.ɵɵrestoreView(_r13); const ctx_r12 = ɵngcc0.ɵɵnextContext(); return ctx_r12.navigateToMyPage(); });
    ɵngcc0.ɵɵi18n(2, 4);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelement(3, "wtc-shared-offer-view", 5);
    ɵngcc0.ɵɵelementStart(4, "div");
    ɵngcc0.ɵɵtemplate(5, OfferActionsComponent_ng_container_0_div_5_Template, 2, 0, "div", 6);
    ɵngcc0.ɵɵelementStart(6, "div");
    ɵngcc0.ɵɵelementStart(7, "button", 7);
    ɵngcc0.ɵɵlistener("click", function OfferActionsComponent_ng_container_0_Template_button_click_7_listener() { ɵngcc0.ɵɵrestoreView(_r13); const ctx_r14 = ɵngcc0.ɵɵnextContext(); return ctx_r14.acceptOffer(); });
    ɵngcc0.ɵɵtemplate(8, OfferActionsComponent_ng_container_0_mat_spinner_8_Template, 1, 0, "mat-spinner", 8);
    ɵngcc0.ɵɵtemplate(9, OfferActionsComponent_ng_container_0_mat_icon_9_Template, 2, 0, "mat-icon", 9);
    ɵngcc0.ɵɵtemplate(10, OfferActionsComponent_ng_container_0_span_10_Template, 2, 0, "span", 0);
    ɵngcc0.ɵɵtemplate(11, OfferActionsComponent_ng_container_0_span_11_Template, 2, 0, "span", 0);
    ɵngcc0.ɵɵtemplate(12, OfferActionsComponent_ng_container_0_span_12_Template, 2, 0, "span", 0);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵtemplate(13, OfferActionsComponent_ng_container_0_a_13_Template, 4, 4, "a", 10);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const ctx_r0 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("color", ctx_r0.config.brandConfig.styles.offerPageButtonType)("ngClass", ctx_r0.config.brandConfig.styles.offerPageButtonClass);
    ɵngcc0.ɵɵadvance(2);
    ɵngcc0.ɵɵproperty("offerData", ctx_r0.offerData);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵclassMap(ctx_r0.config.brandConfig.styles.actionsBlockClass);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngIf", !ctx_r0.offerData.status);
    ɵngcc0.ɵɵadvance(2);
    ɵngcc0.ɵɵproperty("color", ctx_r0.config.brandConfig.styles.offerPageButtonType)("ngClass", ctx_r0.config.brandConfig.styles.offerPageButtonClass)("disabled", ctx_r0.offerAcceptStatusLoader || ctx_r0.offerDeclineStatusLoader || ctx_r0.offerData.status || !ctx_r0.profileService.isPdfReaded);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngIf", ctx_r0.offerAcceptStatusLoader);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngIf", ctx_r0.offerData.status);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngIf", !ctx_r0.offerData.status);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngIf", ctx_r0.offerData.status === ctx_r0.offerStatuses.ACCEPT);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngIf", ctx_r0.offerData.status === ctx_r0.offerStatuses.DECLINE);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngIf", !ctx_r0.offerData.status);
} }
function OfferActionsComponent_div_1_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "div", 20);
    ɵngcc0.ɵɵelement(1, "mat-spinner", 21);
    ɵngcc0.ɵɵelementEnd();
} }
function ProfileTabsComponent_ng_template_3_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "span", 13);
    ɵngcc0.ɵɵtext(1);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r0 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵproperty("ngClass", ctx_r0.config.brandConfig.styles.tabsColor);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵtextInterpolate(ctx_r0.getLables("profile_label"));
} }
function ProfileTabsComponent_ng_template_27_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "span", 13);
    ɵngcc0.ɵɵtext(1);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r1 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵproperty("ngClass", ctx_r1.config.brandConfig.styles.tabsColor);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵtextInterpolate(ctx_r1.getLables("documents_label"));
} }
function ProfileTabsComponent_div_28_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "div", 14);
    ɵngcc0.ɵɵelement(1, "mat-spinner", 15);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r2 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵpropertyInterpolate("color", ctx_r2.config.brandConfig.styles.spinnerColor);
} }
function ProfileTabsComponent_div_29_mat_list_item_4_span_4_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "span", 28);
    ɵngcc0.ɵɵi18n(1, 29);
    ɵngcc0.ɵɵelementEnd();
} }
function ProfileTabsComponent_div_29_mat_list_item_4_span_5_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "span", 30);
    ɵngcc0.ɵɵelementStart(1, "mat-icon", 31);
    ɵngcc0.ɵɵtext(2, "done");
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(3, "span");
    ɵngcc0.ɵɵi18n(4, 32);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
} }
function ProfileTabsComponent_div_29_mat_list_item_4_span_6_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "span", 33);
    ɵngcc0.ɵɵelementStart(1, "mat-icon", 31);
    ɵngcc0.ɵɵtext(2, "close");
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(3, "span");
    ɵngcc0.ɵɵi18n(4, 34);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
} }
function ProfileTabsComponent_div_29_mat_list_item_4_Template(rf, ctx) { if (rf & 1) {
    const _r10 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "mat-list-item", 21);
    ɵngcc0.ɵɵelementStart(1, "div", 7);
    ɵngcc0.ɵɵtext(2);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(3, "div", 22);
    ɵngcc0.ɵɵtemplate(4, ProfileTabsComponent_div_29_mat_list_item_4_span_4_Template, 2, 0, "span", 23);
    ɵngcc0.ɵɵtemplate(5, ProfileTabsComponent_div_29_mat_list_item_4_span_5_Template, 5, 0, "span", 24);
    ɵngcc0.ɵɵtemplate(6, ProfileTabsComponent_div_29_mat_list_item_4_span_6_Template, 5, 0, "span", 25);
    ɵngcc0.ɵɵelementStart(7, "span", 26);
    ɵngcc0.ɵɵtext(8);
    ɵngcc0.ɵɵpipe(9, "date");
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(10, "mat-icon", 27);
    ɵngcc0.ɵɵlistener("click", function ProfileTabsComponent_div_29_mat_list_item_4_Template_mat_icon_click_10_listener() { ɵngcc0.ɵɵrestoreView(_r10); const document_r5 = ctx.$implicit; const ctx_r9 = ɵngcc0.ɵɵnextContext(2); return ctx_r9.handleOfferActions(document_r5); });
    ɵngcc0.ɵɵtext(11, "keyboard_arrow_right ");
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const document_r5 = ctx.$implicit;
    const ctx_r4 = ɵngcc0.ɵɵnextContext(2);
    ɵngcc0.ɵɵadvance(2);
    ɵngcc0.ɵɵtextInterpolate(document_r5.documentName);
    ɵngcc0.ɵɵadvance(2);
    ɵngcc0.ɵɵproperty("ngIf", !document_r5.status);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngIf", document_r5.status === ctx_r4.offerStatuses.ACCEPT);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngIf", document_r5.status === ctx_r4.offerStatuses.DECLINE);
    ɵngcc0.ɵɵadvance(2);
    ɵngcc0.ɵɵtextInterpolate1(" ", ɵngcc0.ɵɵpipeBind2(9, 7, document_r5.created, "dd.MM.yyyy"), " ");
    ɵngcc0.ɵɵadvance(2);
    ɵngcc0.ɵɵclassMap("download-documents-arrow cursor-pointer " + ctx_r4.actionIconsClass);
} }
function ProfileTabsComponent_div_29_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "div", 16);
    ɵngcc0.ɵɵelementStart(1, "mat-list", 17);
    ɵngcc0.ɵɵelementStart(2, "h5", 18);
    ɵngcc0.ɵɵi18n(3, 19);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵtemplate(4, ProfileTabsComponent_div_29_mat_list_item_4_Template, 12, 10, "mat-list-item", 20);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r3 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵadvance(4);
    ɵngcc0.ɵɵproperty("ngForOf", ctx_r3.documents);
} }
class MyPageSharedService {
    constructor() { }
}
MyPageSharedService.ɵfac = function MyPageSharedService_Factory(t) { return new (t || MyPageSharedService)(); };
/** @nocollapse */ MyPageSharedService.ɵprov = ɵɵdefineInjectable({ factory: function MyPageSharedService_Factory() { return new MyPageSharedService(); }, token: MyPageSharedService, providedIn: "root" });
/** @nocollapse */
MyPageSharedService.ctorParameters = () => [];
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(MyPageSharedService, [{
        type: Injectable,
        args: [{
                providedIn: 'root'
            }]
    }], function () { return []; }, null); })();

class MyPageSharedComponent {
    constructor() { }
    ngOnInit() {
    }
}
MyPageSharedComponent.ɵfac = function MyPageSharedComponent_Factory(t) { return new (t || MyPageSharedComponent)(); };
MyPageSharedComponent.ɵcmp = ɵngcc0.ɵɵdefineComponent({ type: MyPageSharedComponent, selectors: [["wtc-shared-lib"]], decls: 2, vars: 0, template: function MyPageSharedComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵelementStart(0, "p");
        ɵngcc0.ɵɵtext(1, " wtc-shared works! ");
        ɵngcc0.ɵɵelementEnd();
    } }, encapsulation: 2 });
/** @nocollapse */
MyPageSharedComponent.ctorParameters = () => [];
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(MyPageSharedComponent, [{
        type: Component,
        args: [{
                selector: 'wtc-shared-lib',
                template: `
    <p>
      wtc-shared works!
    </p>
  `
            }]
    }], function () { return []; }, null); })();

class BugsnagService {
    constructor(env) {
        this.env = env;
    }
    notifyBugsnagLog(message, additionalData = {}) {
        if (!this.bugsnagClient) {
            this.bugsnagClient = Bugsnag.start({ apiKey: this.env.bugsnagKey });
        }
        this.bugsnagClient.notify(new Error(`wtc - ${message}`), {
            metaData: additionalData,
            severity: 'info'
        });
    }
    notifyBugsnagError(message, additionalData = {}) {
        if (!this.bugsnagClient) {
            this.bugsnagClient = Bugsnag.start({ apiKey: this.env.bugsnagKey });
        }
        this.bugsnagClient.notify(new Error(`wtc - ${message}`), {
            metaData: additionalData,
            severity: 'error'
        });
    }
}
BugsnagService.ɵfac = function BugsnagService_Factory(t) { return new (t || BugsnagService)(ɵngcc0.ɵɵinject('env')); };
BugsnagService.ɵprov = ɵngcc0.ɵɵdefineInjectable({ token: BugsnagService, factory: BugsnagService.ɵfac });
/** @nocollapse */
BugsnagService.ctorParameters = () => [
    { type: undefined, decorators: [{ type: Inject, args: ['env',] }] }
];
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(BugsnagService, [{
        type: Injectable
    }], function () { return [{ type: undefined, decorators: [{
                type: Inject,
                args: ['env']
            }] }]; }, null); })();

class CookiesService {
    getCookie(name) {
        const matches = document.cookie.match(new RegExp('(?:^|; )' +
            name.replace(/([\.$?*|{}\(\)\[\]\\\/\+^])/g, '\\$1') +
            '=([^;]*)'));
        return matches ? decodeURIComponent(matches[1]) : undefined;
    }
    setCookie(name, value, options = {}) {
        options = Object.assign({ path: '/' }, options);
        let expires = options.expires;
        if (typeof expires === 'number' && expires) {
            const d = new Date();
            d.setTime(d.getTime() + expires * 1000);
            expires = options.expires = d;
        }
        if (expires && expires.toUTCString) {
            options.expires = expires.toUTCString();
        }
        value = encodeURIComponent(value);
        let updatedCookie = name + '=' + value;
        for (const propName in options) {
            if (options.hasOwnProperty(propName)) {
                updatedCookie += '; ' + propName;
                const propValue = options[propName];
                if (propValue !== true) {
                    updatedCookie += '=' + propValue;
                }
            }
        }
        document.cookie = updatedCookie;
    }
    deleteCookie(name) {
        this.setCookie(name, '', {
            expires: -1
        });
    }
}
CookiesService.ɵfac = function CookiesService_Factory(t) { return new (t || CookiesService)(); };
CookiesService.ɵprov = ɵngcc0.ɵɵdefineInjectable({ token: CookiesService, factory: CookiesService.ɵfac });
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(CookiesService, [{
        type: Injectable
    }], null, null); })();

const download = download_;
class DownloadFileService {
    downloadFile(fileURL, fileName, fileType = 'application/pdf') {
        const x = new XMLHttpRequest();
        x.open('GET', fileURL, true);
        x.responseType = 'blob';
        x.onload = (e) => {
            download(e.target.response, `${fileName}.pdf`, fileType);
        };
        x.send();
    }
}
DownloadFileService.ɵfac = function DownloadFileService_Factory(t) { return new (t || DownloadFileService)(); };
DownloadFileService.ɵprov = ɵngcc0.ɵɵdefineInjectable({ token: DownloadFileService, factory: DownloadFileService.ɵfac });
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(DownloadFileService, [{
        type: Injectable
    }], null, null); })();

const BRANDS_CONFIG = {
    WATERCIRCLES: {
        acceptLanguage: '',
        header: {
            logoSrc: 'assets/img/logo.png'
        },
        styles: {
            offerPageButtonType: 'primary',
            actionIconsClass: 'text--black-dark opacity--light',
            actionsBlockClass: 'actions-block'
        },
        routesMap: {
            login: '',
            profile: 'tilbud',
            offerInfo: '',
            profileInfo: 'profil'
        }
    },
    WINTERBERGH: {
        acceptLanguage: '',
        header: {
            logoSrc: 'assets/img/logo.png'
        },
        styles: {
            offerPageButtonType: 'secondary',
            actionIconsClass: 'text--orange',
            actionsBlockClass: 'actions-block actions-block--huge-text'
        },
        routesMap: {
            login: '',
            profile: 'tilbud',
            offerInfo: '',
            profileInfo: 'profil'
        }
    },
    WATERCIRCLES_SWEDEN: {
        acceptLanguage: '',
        header: {
            logoSrc: 'assets/img/watercircles@2x.png'
        },
        styles: {
            offerPageButtonType: 'primary',
            offerPageButtonClass: 'round-button',
            actionIconsClass: 'text--black-dark opacity--light',
            actionsBlockClass: 'actions-block',
            offerActionClass: 'font-weight-bold text-primary',
        },
        routesMap: {
            login: '',
            profile: 'offert',
            offerInfo: '',
            profileInfo: 'profil',
            aktiespararnaLanding: 'aktiespararna',
            skattebetalarnaLanding: 'skattebetalarna',
            caravanLanding: 'caravan',
            unikLanding: 'unik'
        }
    },
    SAFETOWN: {
        acceptLanguage: '',
        header: {
            logoSrc: 'assets/img/safetown@2x.png'
        },
        styles: {
            offerPageButtonType: 'primary',
            offerPageButtonClass: 'round-button',
            actionIconsClass: 'text--black-dark opacity--light',
            offerActionClass: 'font-weight-bold text-primary',
            actionsBlockClass: 'actions-block'
        },
        routesMap: {
            login: '',
            profile: 'tilbud',
            offerInfo: '',
            profileInfo: 'profil'
        }
    },
    SELECT: {
        acceptLanguage: '',
        header: {
            logoSrc: 'assets/img/select@2x.png',
        },
        styles: {
            offerPageButtonType: 'primary',
            offerPageButtonClass: 'round-button',
            actionIconsClass: 'text--black-dark opacity--light',
            offerActionClass: 'font-weight-bold',
            actionsBlockClass: 'actions-block',
            headerClass: 'p-0'
        },
        routesMap: {
            login: '',
            profile: 'tilbud',
            offerInfo: '',
            profileInfo: 'profil'
        }
    }
};
const SUB_BRANDS_CONFIG = {
    aktiespararna: {
        acceptLanguage: '',
        header: {
            logoSrc: 'assets/img/aktiespararna@2x.png'
        },
        styles: {
            offerPageButtonType: 'primary',
            offerPageButtonClass: 'round-button aktiespararna-offer-btn',
            actionIconsClass: 'text--black-dark opacity--light aktiespararna-offer-arrow',
            actionsBlockClass: 'actions-block',
            offerActionClass: 'font-weight-bold aktiespararna-offer-text',
            logoutBtn: 'aktiespararna-logout',
            spinnerColor: 'aktiespararna',
            tabsColor: 'aktiespararna-tabs',
        },
        routesMap: {
            login: 'aktiespararna',
            profile: 'offert',
            offerInfo: '',
            profileInfo: 'profil'
        }
    },
    caravan: {
        acceptLanguage: '',
        header: {
            logoSrc: 'assets/img/caravan@2x.png'
        },
        styles: {
            offerPageButtonType: 'primary',
            offerPageButtonClass: 'round-button caravan-offer-btn',
            actionIconsClass: 'text--black-dark opacity--light caravan-offer-arrow',
            actionsBlockClass: 'actions-block',
            offerActionClass: 'font-weight-bold caravan-offer-text',
            logoutBtn: 'caravan-logout',
            spinnerColor: 'caravan',
            tabsColor: 'caravan-tabs'
        },
        routesMap: {
            login: 'caravan',
            profile: 'offert',
            offerInfo: '',
            profileInfo: 'profil'
        }
    },
    unik: {
        acceptLanguage: '',
        header: {
            logoSrc: 'assets/img/unik@2x.png'
        },
        styles: {
            offerPageButtonType: 'primary',
            offerPageButtonClass: 'round-button unik-offer-btn',
            actionIconsClass: 'text--black-dark opacity--light unik-offer-arrow',
            actionsBlockClass: 'actions-block',
            offerActionClass: 'font-weight-bold unik-offer-text',
            logoutBtn: 'unik-logout',
            spinnerColor: 'unik',
            tabsColor: 'unik-tabs'
        },
        routesMap: {
            login: 'unik',
            profile: 'offert',
            offerInfo: '',
            profileInfo: 'profil'
        }
    },
    skattebetalarna: {
        acceptLanguage: '',
        header: {
            logoSrc: 'assets/img/skattebetalarna@2x.png'
        },
        styles: {
            offerPageButtonType: 'primary',
            offerPageButtonClass: 'round-button skattebetalarna-offer-btn',
            actionIconsClass: 'text--black-dark opacity--light skattebetalarna-offer-arrow',
            actionsBlockClass: 'actions-block',
            offerActionClass: 'font-weight-bold skattebetalarna-offer-text',
            logoutBtn: 'skattebetalarna-logout',
            spinnerColor: 'skattebetalarna',
            tabsColor: 'skattebetalarna-tabs'
        },
        routesMap: {
            login: 'skattebetalarna',
            profile: 'offert',
            offerInfo: '',
            profileInfo: 'profil'
        }
    },
};
const SUB_BRANDS_MAP = {
    aktiespararna: 'aktiespararna',
    caravan: 'caravan',
    unik: 'unik',
    skattebetalarna: 'skattebetalarna'
};

class ConfigShared {
    constructor(env) {
        this.env = env;
        this.namePattern = [
            '^(([a-zA-ZÅåÄäÖöØøÆæÉéÈèÜüÊêÛûÎî]{0,}([a-zA-ZÅåÄäÖöØøÆæÉéÈèÜüÊêÛûÎî\'\\-]+)' +
                '?[a-zA-ZÅåÄäÖöØøÆæÉéÈèÜüÊêÛûÎî][\'\\.]?)\\s+)+',
            '(([a-zA-ZÅåÄäÖöØøÆæÉéÈèÜüÊêÛûÎî]{0,}([a-zA-ZÅåÄäÖöØøÆæÉéÈèÜüÊêÛûÎî\'\\-]+)' +
                '?[a-zA-ZÅåÄäÖöØøÆæÉéÈèÜüÊêÛûÎî][\'\\.]?)\\s{0,})$'
        ].join('');
        this.emailPattern = [
            '^(([^<>()[\\]\\\.,;:\\s@\\"]+(\\.[^<>()[\\]\\\.,;:\\s@\\"]+)*)|',
            '(\\".+\\"))@((\\[[0-9]{1,3}\\.[0-9]{1,3}\\.[0-9]{1,3}\\.[0-9]{1,3}\\])|',
            '(([a-zA-Z\\-0-9]+\\.)+[a-zA-Z]{2,}))$'
        ].join('');
        this.ssnPattern = '^[0-9]{11}$';
        this.yearPattern = '^[0-9]{4}$';
        this.phonePattern = '^(0047|\\+47|47)?\\d{8}$';
        this.phonePatternShort = '[0-9]{8}$';
        this.dobPattern = '^(0?[1-9]|[12][0-9]|3[01])(0[1-9]|1[0-2])([0-9]{2})$';
        this.profileUrl = '/profile';
        this.offerUrl = '/api/user/offers/latest?brand=';
        this.offerListUrl = '/api/user/offers?brand=';
        this.offerActionsUrl = '/api/offers/{id}';
        this.accessTokenKey = '';
        this.updateBrandConfig = (brand) => {
            this.brandConfig = SUB_BRANDS_CONFIG[brand];
            this.pages = SUB_BRANDS_CONFIG[brand].routesMap;
        };
        const appConfig = this.env;
        this.brandConfig = BRANDS_CONFIG[this.env.brand];
        this.pages = BRANDS_CONFIG[this.env.brand].routesMap;
        this.offerUrl += this.env.apiBrand;
        this.offerListUrl += this.env.apiBrand;
        Object.assign(this, appConfig);
    }
}
ConfigShared.ɵfac = function ConfigShared_Factory(t) { return new (t || ConfigShared)(ɵngcc0.ɵɵinject('env')); };
/** @nocollapse */ ConfigShared.ɵprov = ɵɵdefineInjectable({ factory: function ConfigShared_Factory() { return new ConfigShared(ɵɵinject("env")); }, token: ConfigShared, providedIn: "root" });
/** @nocollapse */
ConfigShared.ctorParameters = () => [
    { type: undefined, decorators: [{ type: Inject, args: ['env',] }] }
];
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(ConfigShared, [{
        type: Injectable,
        args: [{ providedIn: 'root' }]
    }], function () { return [{ type: undefined, decorators: [{
                type: Inject,
                args: ['env']
            }] }]; }, null); })();

class GenericHttp {
    constructor(env, http, config, cookiesService) {
        this.env = env;
        this.http = http;
        this.config = config;
        this.cookiesService = cookiesService;
        this.deafultContentType = {
            name: 'Content-Type',
            value: 'application/json;charset=utf-8'
        };
        this.deafultAcceptType = {
            name: 'Accept',
            value: 'application/json'
        };
        this.setLanguageType = {
            name: 'Accept-Language',
            value: ''
        };
        this.apiUrl = config.baseUrl;
        this.keyKloakApiUrl = this.env.keycloak.url;
        this.setLanguageType.value = config.brandConfig.acceptLanguage;
        this.accessErrorSource = new BehaviorSubject(false);
        this.accessError = this.accessErrorSource.asObservable();
    }
    get(path, queryParams = {}, unautorizedErr) {
        let params = '';
        let fullPath = `${this.apiUrl}${path}`;
        Object.keys(queryParams).forEach(key => {
            params = params + key + '=' + queryParams[key] + '&';
        });
        if (params) {
            params = '?' + params.replace(/&$/, '');
            fullPath = fullPath + params;
        }
        const httpOptions = {
            headers: this.shapeHeaders()
        };
        return this.http.get(fullPath, httpOptions)
            .pipe(catchError((error) => this.handleError(error, unautorizedErr)));
    }
    post(path, body = {}, queryParams = {}) {
        let params = '';
        let fullPath = `${this.apiUrl}${path}`;
        Object.keys(queryParams).forEach(key => {
            params = params + key + '=' + queryParams[key] + '&';
        });
        if (params) {
            params = '?' + params.replace(/&$/, '');
            fullPath = fullPath + params;
        }
        const jsonBody = JSON.stringify(body);
        const httpOptions = {
            headers: this.shapeHeaders()
        };
        return this.http.post(fullPath, jsonBody, httpOptions)
            .pipe(catchError((error) => this.handleError(error, false)));
    }
    patch(path, body = {}, queryParams = {}) {
        let params = '';
        let fullPath = `${this.apiUrl}${path}`;
        Object.keys(queryParams).forEach(key => {
            params = params + key + '=' + queryParams[key] + '&';
        });
        if (params) {
            params = '?' + params.replace(/&$/, '');
            fullPath = fullPath + params;
        }
        const jsonBody = JSON.stringify(body);
        const httpOptions = {
            headers: this.shapeHeaders()
        };
        return this.http.patch(fullPath, jsonBody, httpOptions)
            .pipe(catchError((error) => this.handleError(error, false)));
    }
    del(path, body = {}) {
        const fullPath = `${this.apiUrl}${path}`;
        const httpOptions = {
            headers: this.shapeHeaders()
        };
        return this.http.request('delete', fullPath, { body, headers: httpOptions.headers })
            .pipe(catchError((error) => this.handleError(error, false)));
    }
    put(path, body = {}) {
        const fullPath = `${this.apiUrl}${path}`;
        const jsonBody = JSON.stringify(body);
        const httpOptions = {
            headers: this.shapeHeaders()
        };
        return this.http.put(fullPath, jsonBody, httpOptions)
            .pipe(catchError((error) => this.handleError(error, false)));
    }
    getFile(path) {
        const fullPath = `${this.apiUrl}${path}`;
        const httpOptions = {
            responseType: 'blob',
            headers: this.shapeHeaders()
        };
        return this.http.get(fullPath, httpOptions);
    }
    shapeHeaders() {
        const accessToken = this.cookiesService
            .getCookie(this.config.accessTokenKey);
        let headers = new HttpHeaders()
            .set(this.deafultContentType.name, this.deafultContentType.value)
            .set(this.deafultAcceptType.name, this.deafultAcceptType.value);
        if (this.setLanguageType.value) {
            headers.set(this.setLanguageType.name, this.setLanguageType.value);
        }
        if (Boolean(accessToken)) {
            headers = headers.append('Authorization', `Bearer ${accessToken}`);
        }
        return headers;
    }
    handleError(responseError, unautorizedErr) {
        if (responseError.status === 401 && !unautorizedErr) {
            this.accessErrorSource.next(true);
        }
        return throwError(responseError.error);
    }
}
GenericHttp.ɵfac = function GenericHttp_Factory(t) { return new (t || GenericHttp)(ɵngcc0.ɵɵinject('env'), ɵngcc0.ɵɵinject(ɵngcc1.HttpClient), ɵngcc0.ɵɵinject(ConfigShared), ɵngcc0.ɵɵinject(CookiesService)); };
GenericHttp.ɵprov = ɵngcc0.ɵɵdefineInjectable({ token: GenericHttp, factory: GenericHttp.ɵfac });
/** @nocollapse */
GenericHttp.ctorParameters = () => [
    { type: undefined, decorators: [{ type: Inject, args: ['env',] }] },
    { type: HttpClient },
    { type: ConfigShared },
    { type: CookiesService }
];
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(GenericHttp, [{
        type: Injectable
    }], function () { return [{ type: undefined, decorators: [{
                type: Inject,
                args: ['env']
            }] }, { type: ɵngcc1.HttpClient }, { type: ConfigShared }, { type: CookiesService }]; }, null); })();

class ProfileApiService {
    constructor(wtchttp, config) {
        this.wtchttp = wtchttp;
        this.config = config;
        this.profileDataUrl = config.profileUrl;
        this.offerDataUrl = config.offerUrl;
        this.offerActionsUrl = config.offerActionsUrl;
        this.offerListUrl = config.offerListUrl;
    }
    getUsersData() {
        return this.wtchttp.get(this.profileDataUrl);
    }
    getOffer() {
        return this.wtchttp.get(this.offerDataUrl);
    }
    getOfferList() {
        return this.wtchttp.get(this.offerListUrl);
    }
    getOfferById(offerId) {
        const url = this.offerActionsUrl.replace('{id}', offerId);
        return this.wtchttp.get(url);
    }
    setOfferStatus(offerId, dataToSend) {
        const url = this.offerActionsUrl.replace('{id}', offerId);
        return this.wtchttp.patch(url, dataToSend);
    }
}
ProfileApiService.ɵfac = function ProfileApiService_Factory(t) { return new (t || ProfileApiService)(ɵngcc0.ɵɵinject(GenericHttp), ɵngcc0.ɵɵinject(ConfigShared)); };
ProfileApiService.ɵprov = ɵngcc0.ɵɵdefineInjectable({ token: ProfileApiService, factory: ProfileApiService.ɵfac });
/** @nocollapse */
ProfileApiService.ctorParameters = () => [
    { type: GenericHttp },
    { type: ConfigShared }
];
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(ProfileApiService, [{
        type: Injectable
    }], function () { return [{ type: GenericHttp }, { type: ConfigShared }]; }, null); })();

class HeaderComponent {
    constructor(config) {
        this.config = config;
        this.customLogo = '';
    }
    ngOnInit() {
    }
}
HeaderComponent.ɵfac = function HeaderComponent_Factory(t) { return new (t || HeaderComponent)(ɵngcc0.ɵɵdirectiveInject(ConfigShared)); };
HeaderComponent.ɵcmp = ɵngcc0.ɵɵdefineComponent({ type: HeaderComponent, selectors: [["wtc-shared-header"]], inputs: { customLogo: "customLogo" }, decls: 2, vars: 2, consts: [[1, "header", "text-center", 3, "ngClass"], ["alt", "logo", 1, "header__img", 3, "src"]], template: function HeaderComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵelementStart(0, "div", 0);
        ɵngcc0.ɵɵelement(1, "img", 1);
        ɵngcc0.ɵɵelementEnd();
    } if (rf & 2) {
        ɵngcc0.ɵɵproperty("ngClass", ctx.config.brandConfig.styles.headerClass);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("src", ctx.customLogo ? ctx.customLogo : ctx.config.brandConfig.header.logoSrc, ɵngcc0.ɵɵsanitizeUrl);
    } }, directives: [ɵngcc2.NgClass], encapsulation: 2 });
/** @nocollapse */
HeaderComponent.ctorParameters = () => [
    { type: ConfigShared }
];
HeaderComponent.propDecorators = {
    customLogo: [{ type: Input }]
};
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(HeaderComponent, [{
        type: Component,
        args: [{
                selector: 'wtc-shared-header',
                template: "<div class=\"header text-center\" [ngClass]=\"config.brandConfig.styles.headerClass\">\n  <img class=\"header__img\" [src]=\"customLogo ? customLogo : config.brandConfig.header.logoSrc\" alt=\"logo\" />\n</div>\n"
            }]
    }], function () { return [{ type: ConfigShared }]; }, { customLogo: [{
            type: Input
        }] }); })();

const MESSAGE_TYPES = {
    error: 'error',
    info: 'info',
    success: 'success'
};
const MESSAGE_CLASS_NAMES = {
    error: 'form__validation--error',
    success: 'form__validation--success'
};
const NOT_FOUND_MSG_TYPE = 'SOMETHING_WENT_WRONG';
const NOTIFICATION_MESSAGES = 'NOTIFICATIONS_MESSAGES';
const MESSAGE_DELAY = 5000;

class MessageService {
    constructor() {
        this.showGlobalMessage$ = new Subject();
        this.isActive = false;
        this.delay = MESSAGE_DELAY;
        this.msgValue = '';
    }
    showGlobalMessage(msg) {
        this.showGlobalMessage$.next({ msg });
    }
    parseError(error) {
        const message = error;
        const type = MESSAGE_TYPES.error;
        return [message, type];
    }
}
MessageService.ɵfac = function MessageService_Factory(t) { return new (t || MessageService)(); };
MessageService.ɵprov = ɵngcc0.ɵɵdefineInjectable({ token: MessageService, factory: MessageService.ɵfac });
/** @nocollapse */
MessageService.ctorParameters = () => [];
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(MessageService, [{
        type: Injectable
    }], function () { return []; }, null); })();

class MessagesComponent {
    constructor(messageService, snackBar) {
        this.messageService = messageService;
        this.snackBar = snackBar;
        this.hideMessage = false;
    }
    ngOnInit() {
        this.messageService.showGlobalMessage$.subscribe(msgData => {
            this.openGlobalMessage(msgData);
        });
    }
    closeMsg() {
        this.hideMessage = true;
    }
    openGlobalMessage(msgData) {
        this.snackBar.open(`${msgData.msg.title}: ${msgData.msg.detail}`, 'Lukk', {
            duration: MESSAGE_DELAY,
            horizontalPosition: 'center',
            verticalPosition: 'top',
        });
    }
}
MessagesComponent.ɵfac = function MessagesComponent_Factory(t) { return new (t || MessagesComponent)(ɵngcc0.ɵɵdirectiveInject(MessageService), ɵngcc0.ɵɵdirectiveInject(ɵngcc3.MatSnackBar)); };
MessagesComponent.ɵcmp = ɵngcc0.ɵɵdefineComponent({ type: MessagesComponent, selectors: [["wtc-shared-messages"]], inputs: { message: "message", size: "size", width: "width", type: "type", globalBox: "globalBox", boxClass: "boxClass" }, decls: 1, vars: 1, consts: [[3, "class", "ngClass", 4, "ngIf"], [3, "ngClass"], ["aria-hidden", "false", "aria-label", "info", 4, "ngIf"], ["class", "validation-message-icon validation-message-icon-close", "aria-hidden", "false", "aria-label", "info", 3, "click", 4, "ngIf"], [1, "validation-message-content"], ["aria-hidden", "false", "aria-label", "info"], ["aria-hidden", "false", "aria-label", "info", 1, "validation-message-icon", "validation-message-icon-close", 3, "click"]], template: function MessagesComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵtemplate(0, MessagesComponent_div_0_Template, 10, 15, "div", 0);
    } if (rf & 2) {
        ɵngcc0.ɵɵproperty("ngIf", ctx.type && !ctx.hideMessage);
    } }, directives: [ɵngcc2.NgIf, ɵngcc2.NgClass, ɵngcc4.MatIcon], styles: [""] });
/** @nocollapse */
MessagesComponent.ctorParameters = () => [
    { type: MessageService },
    { type: MatSnackBar }
];
MessagesComponent.propDecorators = {
    message: [{ type: Input }],
    size: [{ type: Input }],
    width: [{ type: Input }],
    type: [{ type: Input }],
    globalBox: [{ type: Input }],
    boxClass: [{ type: Input }]
};
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(MessagesComponent, [{
        type: Component,
        args: [{
                selector: 'wtc-shared-messages',
                template: "<div class=\"validation-message {{boxClass}}\"\n    [ngClass]=\"{\n      'validation-message--error': type === 'error',\n      'validation-message--success': type === 'success',\n      'validation-message--size-large': size === 'large',\n      'validation-message--full-width': width === 'full'\n    }\"\n    *ngIf=\"type && !hideMessage\">\n\n  <mat-icon *ngIf=\"type === 'info'\" aria-hidden=\"false\" aria-label=\"info\">info</mat-icon>\n  <mat-icon *ngIf=\"type === 'check'\" aria-hidden=\"false\" aria-label=\"info\">check</mat-icon>\n  <mat-icon *ngIf=\"type === 'warning'\" aria-hidden=\"false\" aria-label=\"info\">warning</mat-icon>\n\n  <mat-icon *ngIf=\"type === 'warning'\"\n    (click)=\"closeMsg()\"\n    class=\"validation-message-icon validation-message-icon-close\"\n    aria-hidden=\"false\" aria-label=\"info\">close</mat-icon>\n\n  <div class=\"validation-message-content\">\n    <h5>\n      {{ message.title }}\n    </h5>\n    <p>\n      {{ message.detail }}\n    </p>\n  </div>\n</div>\n",
                styles: [""]
            }]
    }], function () { return [{ type: MessageService }, { type: ɵngcc3.MatSnackBar }]; }, { message: [{
            type: Input
        }], size: [{
            type: Input
        }], width: [{
            type: Input
        }], type: [{
            type: Input
        }], globalBox: [{
            type: Input
        }], boxClass: [{
            type: Input
        }] }); })();

class UserStore {
    constructor() {
        this.user$ = new BehaviorSubject(null);
        this.token$ = new BehaviorSubject(null);
    }
}
UserStore.ɵfac = function UserStore_Factory(t) { return new (t || UserStore)(); };
/** @nocollapse */ UserStore.ɵprov = ɵɵdefineInjectable({ factory: function UserStore_Factory() { return new UserStore(); }, token: UserStore, providedIn: "root" });
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(UserStore, [{
        type: Injectable,
        args: [{ providedIn: 'root' }]
    }], function () { return []; }, null); })();

class ProfileService {
    constructor(profileApiService, downloadFileService, userStore) {
        this.profileApiService = profileApiService;
        this.downloadFileService = downloadFileService;
        this.userStore = userStore;
        this.isPdfReaded = false;
    }
    getOfferData() {
        let result;
        if (this.offerData) {
            result = new Observable((observer) => {
                observer.next(this.offerData);
                observer.complete();
            });
        }
        else {
            result = this.profileApiService.getOffer()
                .pipe(tap((response) => {
                this.offerData = response;
                this.userStore.user$.next({
                    user: {
                        fullName: `${response.firstName} ${response.lastName}`,
                        id: response.id,
                        token: this.userStore.token$.value
                    }
                });
            }));
        }
        return result;
    }
    getOfferListData() {
        let result;
        if (this.offerListData) {
            result = new Observable((observer) => {
                observer.next(this.offerListData);
                observer.complete();
            });
        }
        else {
            result = this.profileApiService.getOfferList()
                .pipe(tap((response) => {
                this.offerListData = response;
                this.userStore.user$.next({
                    user: {
                        fullName: `${response.firstName} ${response.lastName}`,
                        id: response.id,
                        token: this.userStore.token$.value
                    }
                });
            }));
        }
        return result;
    }
    getFullName() {
        return `${this.offerData.firstName} ${this.offerData.lastName}`;
    }
    clearData() {
        this.offerData = undefined;
        this.offerListData = undefined;
        this.isPdfReaded = false;
    }
    pdfViewerLoaded(viewerSelector = '#viewerContainer') {
        const pdfViewerContainer = document.querySelector(viewerSelector);
        if (pdfViewerContainer) {
            pdfViewerContainer.removeEventListener('scroll', () => {
            });
            pdfViewerContainer.addEventListener('scroll', (event) => {
                const element = event.target;
                // console.log('element.scrollHeight - ', element.scrollHeight, element.scrollTop, element.clientHeight);
                if (element) {
                    if (Math.round(element.scrollHeight - element.scrollTop) === element.clientHeight ||
                        Math.round(element.scrollHeight - element.scrollTop) === element.clientHeight + 1) {
                        this.isPdfReaded = true;
                    }
                }
            }, false);
        }
    }
    downloadPdf(url, filename) {
        this.downloadFileService.downloadFile(url, filename);
    }
}
ProfileService.ɵfac = function ProfileService_Factory(t) { return new (t || ProfileService)(ɵngcc0.ɵɵinject(ProfileApiService), ɵngcc0.ɵɵinject(DownloadFileService), ɵngcc0.ɵɵinject(UserStore)); };
ProfileService.ɵprov = ɵngcc0.ɵɵdefineInjectable({ token: ProfileService, factory: ProfileService.ɵfac });
/** @nocollapse */
ProfileService.ctorParameters = () => [
    { type: ProfileApiService },
    { type: DownloadFileService },
    { type: UserStore }
];
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(ProfileService, [{
        type: Injectable
    }], function () { return [{ type: ProfileApiService }, { type: DownloadFileService }, { type: UserStore }]; }, null); })();

class LoginService {
    constructor(config, keycloakService, profileService, userStore) {
        this.config = config;
        this.keycloakService = keycloakService;
        this.profileService = profileService;
        this.userStore = userStore;
    }
    keykloakAction(redirectUriToSet = '', actionToSet = '', localeToSet = '', idHintToSet = '') {
        class LoginOptions {
            constructor() {
                this.redirectUri = redirectUriToSet;
                this.action = actionToSet;
                this.locale = localeToSet;
                // signicat-providersignicat-oidc signicat-bankid-oidc preprod-oidc-test signicat-mobile-provider
                this.idpHint = idHintToSet;
            }
        }
        const loginOptions = new LoginOptions();
        this.keycloakService.login(loginOptions);
    }
    getKeykloakToken() {
        this.keycloakService.getToken().then(e => {
            console.log('getToken: ', e);
            this.userStore.token$.next(e);
        });
    }
    logoutKeykloak() {
        this.keycloakService.logout(`${window.location.origin}/${this.config.pages.login}`);
        this.profileService.clearData();
    }
}
LoginService.ɵfac = function LoginService_Factory(t) { return new (t || LoginService)(ɵngcc0.ɵɵinject(ConfigShared), ɵngcc0.ɵɵinject(ɵngcc5.KeycloakService), ɵngcc0.ɵɵinject(ProfileService), ɵngcc0.ɵɵinject(UserStore)); };
LoginService.ɵprov = ɵngcc0.ɵɵdefineInjectable({ token: LoginService, factory: LoginService.ɵfac });
/** @nocollapse */
LoginService.ctorParameters = () => [
    { type: ConfigShared },
    { type: KeycloakService },
    { type: ProfileService },
    { type: UserStore }
];
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(LoginService, [{
        type: Injectable
    }], function () { return [{ type: ConfigShared }, { type: ɵngcc5.KeycloakService }, { type: ProfileService }, { type: UserStore }]; }, null); })();

const DECLINE_REASONS = {
    PRICE_NOT_GOOD_ENOUGH: false,
    ERRORS_IN_OFFER: false,
    MISSING_INSURANCES_IN_OFFER: false,
    POOR_CUSTOMER_EXPERIENCE: false,
    DO_NOT_BELIEVE_IN_THE_CONCEPT: false
};
const OFFER_SUCCESS = {
    cards: [
        {
            content: 'FLOW_DATA.OFFER_SUCCESS.CARDS.0.CONTENT',
            layoutClass: 'col-lg-6 col-wrap'
        },
        {
            content: 'FLOW_DATA.OFFER_SUCCESS.CARDS.1.CONTENT',
            layoutClass: 'col-lg-6 col-wrap'
        },
        {
            content: 'FLOW_DATA.OFFER_SUCCESS.CARDS.2.CONTENT',
            layoutClass: 'col-lg-6 col-wrap'
        },
        {
            content: 'FLOW_DATA.OFFER_SUCCESS.CARDS.3.CONTENT',
            layoutClass: 'col-lg-6 col-wrap'
        }
    ]
};
const OFFER_STATUSES = {
    ACCEPT: 'ACCEPT',
    DECLINE: 'DECLINE'
};

class PdfViewDialogComponent {
    constructor(dialogRef, profileService, data) {
        this.dialogRef = dialogRef;
        this.profileService = profileService;
        this.data = data;
        this.pdfRendered = false;
        this.offerStatuses = OFFER_STATUSES;
    }
    onNoClick() {
        this.dialogRef.close(true);
    }
    onPdfLoaded() {
        if (this.data.listenScrollBottomEvent) {
            this.profileService.pdfViewerLoaded();
        }
    }
}
PdfViewDialogComponent.ɵfac = function PdfViewDialogComponent_Factory(t) { return new (t || PdfViewDialogComponent)(ɵngcc0.ɵɵdirectiveInject(ɵngcc6.MatDialogRef), ɵngcc0.ɵɵdirectiveInject(ProfileService), ɵngcc0.ɵɵdirectiveInject(MAT_DIALOG_DATA)); };
PdfViewDialogComponent.ɵcmp = ɵngcc0.ɵɵdefineComponent({ type: PdfViewDialogComponent, selectors: [["wtc-shared-pdf-view"]], decls: 12, vars: 8, consts: function () { let i18n_1; if (typeof ngI18nClosureMode !== "undefined" && ngI18nClosureMode) {
        /**
         * @desc Offer download doc
         */
        const MSG_EXTERNAL_offer_download_doc$$FESM2015_WTC_SHARED_JS_2 = goog.getMsg(" Download ");
        i18n_1 = MSG_EXTERNAL_offer_download_doc$$FESM2015_WTC_SHARED_JS_2;
    }
    else {
        i18n_1 = $localize `:Offer download doc@@offer.download_doc␟358322742e12bd78a131cd306c798bc59b41e7d9␟8346753430323811508: Download `;
    } let i18n_3; if (typeof ngI18nClosureMode !== "undefined" && ngI18nClosureMode) {
        /**
         * @desc Offer accepted btn text
         */
        const MSG_EXTERNAL_offer_accepted_btn_text$$FESM2015_WTC_SHARED_JS__4 = goog.getMsg(" Offer accepted ");
        i18n_3 = MSG_EXTERNAL_offer_accepted_btn_text$$FESM2015_WTC_SHARED_JS__4;
    }
    else {
        i18n_3 = $localize `:Offer accepted btn text@@offer.accepted_btn_text␟a656690bd07652ca97e900c4cd56a5f96f6d8467␟5035392188650933385: Offer accepted `;
    } return [["aria-hidden", "false", "aria-label", "info", 1, "wtc-dialog-close-icon", 3, "click"], [1, "position-relative"], [1, "pdf-viewer-box", "pdf-viewer-box--full-screen"], [1, "actions-section", "ml-5", "mb-2"], ["class", "opacity--light d-inline-flex mr-4", 4, "ngIf"], [1, "d-inline-flex", 3, "click"], ["aria-hidden", "false", "aria-label", "info", 1, "mr-2", "text--black-dark", "opacity--light"], i18n_1, ["id", "pdfViewerFullWidth", 3, "src", "enablePinchOnMobile", "mobileFriendlyZoom", "maxZoom", "handTool", "showToolbar", "backgroundColor", "pdfLoaded"], [1, "opacity--light", "d-inline-flex", "mr-4"], ["aria-hidden", "false", "aria-label", "info", 1, "mr-2"], i18n_3]; }, template: function PdfViewDialogComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵelementStart(0, "mat-icon", 0);
        ɵngcc0.ɵɵlistener("click", function PdfViewDialogComponent_Template_mat_icon_click_0_listener() { return ctx.onNoClick(); });
        ɵngcc0.ɵɵtext(1, "close");
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(2, "div", 1);
        ɵngcc0.ɵɵelementStart(3, "div", 2);
        ɵngcc0.ɵɵelementStart(4, "div", 3);
        ɵngcc0.ɵɵtemplate(5, PdfViewDialogComponent_span_5_Template, 5, 0, "span", 4);
        ɵngcc0.ɵɵelementStart(6, "a", 5);
        ɵngcc0.ɵɵlistener("click", function PdfViewDialogComponent_Template_a_click_6_listener() { return ctx.profileService.downloadPdf(ctx.data.documentUrl, ctx.data.documentName); });
        ɵngcc0.ɵɵelementStart(7, "mat-icon", 6);
        ɵngcc0.ɵɵtext(8, "get_app");
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(9, "span");
        ɵngcc0.ɵɵi18n(10, 7);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(11, "ngx-extended-pdf-viewer", 8);
        ɵngcc0.ɵɵlistener("pdfLoaded", function PdfViewDialogComponent_Template_ngx_extended_pdf_viewer_pdfLoaded_11_listener() { ctx.profileService.pdfViewerLoaded(); return ctx.pdfRendered = true; });
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
    } if (rf & 2) {
        ɵngcc0.ɵɵadvance(5);
        ɵngcc0.ɵɵproperty("ngIf", ctx.data.documentStatus === ctx.offerStatuses.ACCEPT);
        ɵngcc0.ɵɵadvance(6);
        ɵngcc0.ɵɵproperty("src", ctx.data.documentUrl)("enablePinchOnMobile", true)("mobileFriendlyZoom", "150%")("maxZoom", 7)("handTool", false)("showToolbar", false)("backgroundColor", "#fff");
    } }, directives: [ɵngcc4.MatIcon, ɵngcc2.NgIf, ɵngcc7.NgxExtendedPdfViewerComponent], encapsulation: 2 });
/** @nocollapse */
PdfViewDialogComponent.ctorParameters = () => [
    { type: MatDialogRef },
    { type: ProfileService },
    { type: undefined, decorators: [{ type: Inject, args: [MAT_DIALOG_DATA,] }] }
];
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(PdfViewDialogComponent, [{
        type: Component,
        args: [{
                selector: 'wtc-shared-pdf-view',
                template: "<mat-icon\n  (click)=\"onNoClick()\"\n  class=\"wtc-dialog-close-icon\"\n  aria-hidden=\"false\" aria-label=\"info\">close</mat-icon>\n\n<div class=\"position-relative\">\n  <div class=\"pdf-viewer-box pdf-viewer-box--full-screen\">\n    <div class=\"actions-section ml-5 mb-2\">\n      <span\n        class=\"opacity--light d-inline-flex mr-4\"\n        *ngIf=\"data.documentStatus === offerStatuses.ACCEPT\">\n        <mat-icon\n          class=\"mr-2\"\n          aria-hidden=\"false\" aria-label=\"info\">done</mat-icon>\n        <span\n          i18n=\"Offer accepted btn text@@offer.accepted_btn_text\">\n          Offer accepted\n        </span>\n      </span>\n  \n      <a\n        (click)=\"profileService.downloadPdf(data.documentUrl, data.documentName)\"\n        class=\"d-inline-flex\">\n        <mat-icon class=\"mr-2 text--black-dark opacity--light\" aria-hidden=\"false\" aria-label=\"info\">get_app</mat-icon>\n        <span i18n=\"Offer download doc@@offer.download_doc\">\n          Download\n        </span>\n      </a>\n    </div>\n\n    <ngx-extended-pdf-viewer\n      id=\"pdfViewerFullWidth\"\n      [src]=\"data.documentUrl\"\n      [enablePinchOnMobile]=\"true\"\n      [mobileFriendlyZoom]=\"'150%'\"\n      [maxZoom]=\"7\"\n      [handTool]=\"false\"\n      [showToolbar]=\"false\"\n      [backgroundColor]=\"'#fff'\"\n      (pdfLoaded)=\"profileService.pdfViewerLoaded(); pdfRendered = true;\">\n    </ngx-extended-pdf-viewer>\n  </div>\n\n  <!-- <div class=\"text-center\" *ngIf=\"pdfRendered\">\n    <button\n      mat-button\n      color=\"primary\"\n      (click)=\"onNoClick()\">\n      Lukk\n    </button>\n  </div> -->\n</div>"
            }]
    }], function () { return [{ type: ɵngcc6.MatDialogRef }, { type: ProfileService }, { type: undefined, decorators: [{
                type: Inject,
                args: [MAT_DIALOG_DATA]
            }] }]; }, null); })();

class TranslateService {
    constructor(i18n) {
        this.i18n = i18n;
    }
    getTranslation(translationId, translationType) {
        return this.i18n({ value: translationType, id: translationId, meaning: translationType });
    }
}
TranslateService.ɵfac = function TranslateService_Factory(t) { return new (t || TranslateService)(ɵngcc0.ɵɵinject(ɵngcc8.I18n)); };
TranslateService.ɵprov = ɵngcc0.ɵɵdefineInjectable({ token: TranslateService, factory: TranslateService.ɵfac });
/** @nocollapse */
TranslateService.ctorParameters = () => [
    { type: I18n }
];
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(TranslateService, [{
        type: Injectable
    }], function () { return [{ type: ɵngcc8.I18n }]; }, null); })();

class DeclineOfferDialogComponent {
    constructor(translateService, dialogRef, data) {
        this.translateService = translateService;
        this.dialogRef = dialogRef;
        this.data = data;
        this.declineOfferLoader = false;
        this.customerComment = '';
        this.userReport = DECLINE_REASONS;
    }
    declineOffer() {
        this.dialogRef.close({
            isOfferDeclined: true,
            reason: this.declineOfferReason
        });
    }
    onNoClick() {
        this.dialogRef.close();
    }
}
DeclineOfferDialogComponent.ɵfac = function DeclineOfferDialogComponent_Factory(t) { return new (t || DeclineOfferDialogComponent)(ɵngcc0.ɵɵdirectiveInject(TranslateService), ɵngcc0.ɵɵdirectiveInject(ɵngcc6.MatDialogRef), ɵngcc0.ɵɵdirectiveInject(MAT_DIALOG_DATA)); };
DeclineOfferDialogComponent.ɵcmp = ɵngcc0.ɵɵdefineComponent({ type: DeclineOfferDialogComponent, selectors: [["wtc-shared-decline-offer-dialog"]], decls: 15, vars: 2, consts: function () { let i18n_5; if (typeof ngI18nClosureMode !== "undefined" && ngI18nClosureMode) {
        /**
         * @desc Decline offer header
         */
        const MSG_EXTERNAL_decline_offer_header$$FESM2015_WTC_SHARED_JS_6 = goog.getMsg(" Decline offer ");
        i18n_5 = MSG_EXTERNAL_decline_offer_header$$FESM2015_WTC_SHARED_JS_6;
    }
    else {
        i18n_5 = $localize `:Decline offer header@@decline_offer.header␟c1598f84dfcbd27ed62ce9bceb5d359c78908c9d␟2775562572814011867: Decline offer `;
    } let i18n_7; if (typeof ngI18nClosureMode !== "undefined" && ngI18nClosureMode) {
        /**
         * @desc Decline offer close btn
         */
        const MSG_EXTERNAL_decline_offer_close_btn$$FESM2015_WTC_SHARED_JS_8 = goog.getMsg(" Close ");
        i18n_7 = MSG_EXTERNAL_decline_offer_close_btn$$FESM2015_WTC_SHARED_JS_8;
    }
    else {
        i18n_7 = $localize `:Decline offer close btn@@decline_offer.close_btn␟396111f33ef48eef016cd0eedb7be2ef882d7430␟1353900317147489199: Close `;
    } let i18n_9; if (typeof ngI18nClosureMode !== "undefined" && ngI18nClosureMode) {
        /**
         * @desc Decline offer decline btn
         */
        const MSG_EXTERNAL_decline_offer_decline_btn$$FESM2015_WTC_SHARED_JS_10 = goog.getMsg(" Decline ");
        i18n_9 = MSG_EXTERNAL_decline_offer_decline_btn$$FESM2015_WTC_SHARED_JS_10;
    }
    else {
        i18n_9 = $localize `:Decline offer decline btn@@decline_offer.decline_btn␟a61a2e1ea2d3722b331feb91ed83ea9f36c5f458␟4805661479627552136: Decline `;
    } return [["aria-hidden", "false", "aria-label", "info", 1, "wtc-dialog-close-icon", 3, "click"], [1, "position-relative", "accept-offer"], [1, "dialog__header", "mb-3"], [1, "text-left"], i18n_5, [1, "p-3", "w-100", 3, "placeholder", "ngModel", "ngModelChange"], ["align", "end"], [1, "mr-5", 3, "click"], i18n_7, ["mat-button", "", "color", "primary", 3, "click"], i18n_9]; }, template: function DeclineOfferDialogComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵelementStart(0, "mat-icon", 0);
        ɵngcc0.ɵɵlistener("click", function DeclineOfferDialogComponent_Template_mat_icon_click_0_listener() { return ctx.onNoClick(); });
        ɵngcc0.ɵɵtext(1, "close");
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(2, "mat-dialog-content", 1);
        ɵngcc0.ɵɵelementContainerStart(3);
        ɵngcc0.ɵɵelementStart(4, "header", 2);
        ɵngcc0.ɵɵelementStart(5, "h4", 3);
        ɵngcc0.ɵɵelementStart(6, "span");
        ɵngcc0.ɵɵi18n(7, 4);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(8, "p");
        ɵngcc0.ɵɵelementStart(9, "textarea", 5);
        ɵngcc0.ɵɵlistener("ngModelChange", function DeclineOfferDialogComponent_Template_textarea_ngModelChange_9_listener($event) { return ctx.declineOfferReason = $event; });
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementContainerEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(10, "mat-dialog-actions", 6);
        ɵngcc0.ɵɵelementStart(11, "a", 7);
        ɵngcc0.ɵɵlistener("click", function DeclineOfferDialogComponent_Template_a_click_11_listener() { return ctx.onNoClick(); });
        ɵngcc0.ɵɵi18n(12, 8);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(13, "button", 9);
        ɵngcc0.ɵɵlistener("click", function DeclineOfferDialogComponent_Template_button_click_13_listener() { return ctx.declineOffer(); });
        ɵngcc0.ɵɵi18n(14, 10);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
    } if (rf & 2) {
        ɵngcc0.ɵɵadvance(9);
        ɵngcc0.ɵɵpropertyInterpolate("placeholder", ctx.translateService.getTranslation("decline_offer.reason", "Decline offer reason"));
        ɵngcc0.ɵɵproperty("ngModel", ctx.declineOfferReason);
    } }, directives: [ɵngcc4.MatIcon, ɵngcc6.MatDialogContent, ɵngcc9.DefaultValueAccessor, ɵngcc9.NgControlStatus, ɵngcc9.NgModel, ɵngcc6.MatDialogActions, ɵngcc10.MatButton], styles: [""] });
/** @nocollapse */
DeclineOfferDialogComponent.ctorParameters = () => [
    { type: TranslateService },
    { type: MatDialogRef },
    { type: undefined, decorators: [{ type: Inject, args: [MAT_DIALOG_DATA,] }] }
];
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(DeclineOfferDialogComponent, [{
        type: Component,
        args: [{
                selector: 'wtc-shared-decline-offer-dialog',
                template: "<mat-icon\n  (click)=\"onNoClick()\"\n  class=\"wtc-dialog-close-icon\"\n  aria-hidden=\"false\" aria-label=\"info\">close</mat-icon>\n\n<mat-dialog-content\n  class=\"position-relative accept-offer\">\n  <ng-container>\n    <header class=\"dialog__header mb-3\">\n      <h4 class=\"text-left\">\n        <span\n          i18n=\"Decline offer header@@decline_offer.header\">\n          Decline offer\n        </span>\n      </h4>\n      <p>\n        <textarea\n          class=\"p-3 w-100\"\n          placeholder=\"{{translateService.getTranslation('decline_offer.reason', 'Decline offer reason')}}\"\n          [(ngModel)]=\"declineOfferReason\"></textarea>\n      </p>\n    </header>\n  </ng-container>\n</mat-dialog-content>\n\n<mat-dialog-actions align=\"end\">\n  <a\n    (click)=\"onNoClick()\"\n    class=\"mr-5\"\n    i18n=\"Decline offer close btn@@decline_offer.close_btn\">\n    Close\n  </a>\n  <button\n    mat-button\n    color=\"primary\"\n    (click)=\"declineOffer()\"\n    i18n=\"Decline offer decline btn@@decline_offer.decline_btn\">\n    Decline\n  </button>\n</mat-dialog-actions>\n",
                styles: [""]
            }]
    }], function () { return [{ type: TranslateService }, { type: ɵngcc6.MatDialogRef }, { type: undefined, decorators: [{
                type: Inject,
                args: [MAT_DIALOG_DATA]
            }] }]; }, null); })();

class AcceptOfferDialogComponent {
    constructor(dialogRef, fb, config, data) {
        this.dialogRef = dialogRef;
        this.fb = fb;
        this.config = config;
        this.data = data;
        this.isOfferAccepted = true;
        this.successDataLoader = false;
    }
    onNoClick() {
        this.dialogRef.close();
    }
    ngOnInit() {
        this.acceptOfferForm = this.initAcceptOfferForm();
    }
    acceptOffer(form) {
        const dataToSend = form.value;
        console.log(dataToSend);
    }
    initAcceptOfferForm() {
        return this.fb.group({
            name: ['', Validators.compose([
                    Validators.required,
                    Validators.pattern(this.config.namePattern)
                ])],
            phone: ['', Validators.compose([
                    Validators.required,
                    Validators.pattern(this.config.phonePattern)
                ])],
            email: ['', Validators.compose([
                    Validators.required,
                    Validators.pattern(this.config.emailPattern)
                ])],
            ssn: ['', Validators.compose([
                    Validators.required,
                    Validators.pattern(this.config.ssnPattern)
                ])],
        });
    }
}
AcceptOfferDialogComponent.ɵfac = function AcceptOfferDialogComponent_Factory(t) { return new (t || AcceptOfferDialogComponent)(ɵngcc0.ɵɵdirectiveInject(ɵngcc6.MatDialogRef), ɵngcc0.ɵɵdirectiveInject(ɵngcc9.FormBuilder), ɵngcc0.ɵɵdirectiveInject(ConfigShared), ɵngcc0.ɵɵdirectiveInject(MAT_DIALOG_DATA)); };
AcceptOfferDialogComponent.ɵcmp = ɵngcc0.ɵɵdefineComponent({ type: AcceptOfferDialogComponent, selectors: [["wtc-shared-accept-offer-dialog"]], decls: 9, vars: 6, consts: function () { let i18n_11; if (typeof ngI18nClosureMode !== "undefined" && ngI18nClosureMode) {
        /**
         * @desc Accept offer close btn
         */
        const MSG_EXTERNAL_accept_offer_close_btn$$FESM2015_WTC_SHARED_JS_12 = goog.getMsg(" Close ");
        i18n_11 = MSG_EXTERNAL_accept_offer_close_btn$$FESM2015_WTC_SHARED_JS_12;
    }
    else {
        i18n_11 = $localize `:Accept offer close btn@@accept_offer.close_btn␟396111f33ef48eef016cd0eedb7be2ef882d7430␟1353900317147489199: Close `;
    } let i18n_13; if (typeof ngI18nClosureMode !== "undefined" && ngI18nClosureMode) {
        /**
         * @desc Success page header
         */
        const MSG_EXTERNAL_success_page_header$$FESM2015_WTC_SHARED_JS__14 = goog.getMsg(" Success! ");
        i18n_13 = MSG_EXTERNAL_success_page_header$$FESM2015_WTC_SHARED_JS__14;
    }
    else {
        i18n_13 = $localize `:Success page header@@success_page.header␟7586f47eccfc61793bdfa789389edd8d1e2cb8cb␟5867776728681011843: Success! `;
    } let i18n_15; if (typeof ngI18nClosureMode !== "undefined" && ngI18nClosureMode) {
        /**
         * @desc Offer succes page description 1
         */
        const MSG_EXTERNAL_success_page_description_1$$FESM2015_WTC_SHARED_JS__16 = goog.getMsg(" Dear {$interpolation} ", { "interpolation": "\uFFFD0\uFFFD" });
        i18n_15 = MSG_EXTERNAL_success_page_description_1$$FESM2015_WTC_SHARED_JS__16;
    }
    else {
        i18n_15 = $localize `:Offer succes page description 1@@success_page.description_1␟2ff256e2e37642a5afdcceb259438a97ef3d466b␟280291641429330284: Dear ${"\uFFFD0\uFFFD"}:INTERPOLATION: `;
    } let i18n_17; if (typeof ngI18nClosureMode !== "undefined" && ngI18nClosureMode) {
        /**
         * @desc Accept offer name
         */
        const MSG_EXTERNAL_accept_offer_name$$FESM2015_WTC_SHARED_JS__18 = goog.getMsg(" Username ");
        i18n_17 = MSG_EXTERNAL_accept_offer_name$$FESM2015_WTC_SHARED_JS__18;
    }
    else {
        i18n_17 = $localize `:Accept offer name@@accept_offer.name␟1a871a8e04bd0fd8b6d91f87c2dc1993be08481c␟5623191120750614201: Username `;
    } let i18n_19; if (typeof ngI18nClosureMode !== "undefined" && ngI18nClosureMode) {
        /**
         * @desc Accept offer email
         */
        const MSG_EXTERNAL_accept_offer_email$$FESM2015_WTC_SHARED_JS__20 = goog.getMsg(" Email ");
        i18n_19 = MSG_EXTERNAL_accept_offer_email$$FESM2015_WTC_SHARED_JS__20;
    }
    else {
        i18n_19 = $localize `:Accept offer email@@accept_offer.email␟21c97d2f1e891d5e385975a60791b031ed34f7ed␟6160342114611398372: Email `;
    } let i18n_21; if (typeof ngI18nClosureMode !== "undefined" && ngI18nClosureMode) {
        /**
         * @desc Accept offer ssn
         */
        const MSG_EXTERNAL_accept_offer_ssn$$FESM2015_WTC_SHARED_JS__22 = goog.getMsg(" Ssn ");
        i18n_21 = MSG_EXTERNAL_accept_offer_ssn$$FESM2015_WTC_SHARED_JS__22;
    }
    else {
        i18n_21 = $localize `:Accept offer ssn@@accept_offer.ssn␟a6edde7170ef03513a4b9ab8726ad29b67417548␟1588590887243302902: Ssn `;
    } let i18n_23; if (typeof ngI18nClosureMode !== "undefined" && ngI18nClosureMode) {
        /**
         * @desc Accept offer phone
         */
        const MSG_EXTERNAL_accept_offer_phone$$FESM2015_WTC_SHARED_JS__24 = goog.getMsg(" Phone ");
        i18n_23 = MSG_EXTERNAL_accept_offer_phone$$FESM2015_WTC_SHARED_JS__24;
    }
    else {
        i18n_23 = $localize `:Accept offer phone@@accept_offer.phone␟8d496215f7eec429384245d9611792d8624cc54a␟3560789847694377919: Phone `;
    } let i18n_25; if (typeof ngI18nClosureMode !== "undefined" && ngI18nClosureMode) {
        /**
         * @desc Is required error
         */
        const MSG_EXTERNAL_form_validation_is_required$$FESM2015_WTC_SHARED_JS___26 = goog.getMsg(" Field is required ");
        i18n_25 = MSG_EXTERNAL_form_validation_is_required$$FESM2015_WTC_SHARED_JS___26;
    }
    else {
        i18n_25 = $localize `:Is required error@@form_validation.is_required␟10f0d609d72917ad517f0797dbf8f6333ec8e8eb␟5468204891246024675: Field is required `;
    } let i18n_27; if (typeof ngI18nClosureMode !== "undefined" && ngI18nClosureMode) {
        /**
         * @desc Name invalid error
         */
        const MSG_EXTERNAL_form_validation_name_invalid$$FESM2015_WTC_SHARED_JS___28 = goog.getMsg(" Name invalid ");
        i18n_27 = MSG_EXTERNAL_form_validation_name_invalid$$FESM2015_WTC_SHARED_JS___28;
    }
    else {
        i18n_27 = $localize `:Name invalid error@@form_validation.name_invalid␟31ab7851dcbf50e2f301eccc487c2439b68ca852␟6919730572036417054: Name invalid `;
    } let i18n_29; if (typeof ngI18nClosureMode !== "undefined" && ngI18nClosureMode) {
        /**
         * @desc Is required error
         */
        const MSG_EXTERNAL_form_validation_is_required$$FESM2015_WTC_SHARED_JS___30 = goog.getMsg(" Field is required ");
        i18n_29 = MSG_EXTERNAL_form_validation_is_required$$FESM2015_WTC_SHARED_JS___30;
    }
    else {
        i18n_29 = $localize `:Is required error@@form_validation.is_required␟60613475bfd5f892a57ca650144a28d2a6b7d2f4␟493706380330213415: Field is required `;
    } let i18n_31; if (typeof ngI18nClosureMode !== "undefined" && ngI18nClosureMode) {
        /**
         * @desc Email invalid error
         */
        const MSG_EXTERNAL_form_validation_email_invalid$$FESM2015_WTC_SHARED_JS___32 = goog.getMsg(" Email invalid ");
        i18n_31 = MSG_EXTERNAL_form_validation_email_invalid$$FESM2015_WTC_SHARED_JS___32;
    }
    else {
        i18n_31 = $localize `:Email invalid error@@form_validation.email_invalid␟081dbb00fd4234165cf6f7ea0eb0735d578afc74␟1564143942080789545: Email invalid `;
    } let i18n_33; if (typeof ngI18nClosureMode !== "undefined" && ngI18nClosureMode) {
        /**
         * @desc Is required error
         */
        const MSG_EXTERNAL_form_validation_is_required$$FESM2015_WTC_SHARED_JS___34 = goog.getMsg(" Field is required ");
        i18n_33 = MSG_EXTERNAL_form_validation_is_required$$FESM2015_WTC_SHARED_JS___34;
    }
    else {
        i18n_33 = $localize `:Is required error@@form_validation.is_required␟60613475bfd5f892a57ca650144a28d2a6b7d2f4␟493706380330213415: Field is required `;
    } let i18n_35; if (typeof ngI18nClosureMode !== "undefined" && ngI18nClosureMode) {
        /**
         * @desc Ssn invalid error
         */
        const MSG_EXTERNAL_form_validation_email_invalid$$FESM2015_WTC_SHARED_JS___36 = goog.getMsg(" Ssn invalid ");
        i18n_35 = MSG_EXTERNAL_form_validation_email_invalid$$FESM2015_WTC_SHARED_JS___36;
    }
    else {
        i18n_35 = $localize `:Ssn invalid error@@form_validation.email_invalid␟1b37ed963d66dab0d4954b0e75075df720825a93␟7947620589528071073: Ssn invalid `;
    } let i18n_37; if (typeof ngI18nClosureMode !== "undefined" && ngI18nClosureMode) {
        /**
         * @desc Is required error
         */
        const MSG_EXTERNAL_form_validation_is_required$$FESM2015_WTC_SHARED_JS___38 = goog.getMsg(" Field is required ");
        i18n_37 = MSG_EXTERNAL_form_validation_is_required$$FESM2015_WTC_SHARED_JS___38;
    }
    else {
        i18n_37 = $localize `:Is required error@@form_validation.is_required␟60613475bfd5f892a57ca650144a28d2a6b7d2f4␟493706380330213415: Field is required `;
    } let i18n_39; if (typeof ngI18nClosureMode !== "undefined" && ngI18nClosureMode) {
        /**
         * @desc Phone invalid error
         */
        const MSG_EXTERNAL_form_validation_phone_invalid$$FESM2015_WTC_SHARED_JS___40 = goog.getMsg(" Phone invalid ");
        i18n_39 = MSG_EXTERNAL_form_validation_phone_invalid$$FESM2015_WTC_SHARED_JS___40;
    }
    else {
        i18n_39 = $localize `:Phone invalid error@@form_validation.phone_invalid␟5c15be9bbe3bcaab72cd282d255340a304ad6f66␟7360114065257211749: Phone invalid `;
    } let i18n_41; if (typeof ngI18nClosureMode !== "undefined" && ngI18nClosureMode) {
        /**
         * @desc Accept offer success btn
         */
        const MSG_EXTERNAL_accept_offer_success_btn$$FESM2015_WTC_SHARED_JS__42 = goog.getMsg(" Send ");
        i18n_41 = MSG_EXTERNAL_accept_offer_success_btn$$FESM2015_WTC_SHARED_JS__42;
    }
    else {
        i18n_41 = $localize `:Accept offer success btn@@accept_offer.success_btn␟939b4d44088b8ece0fd394a0eb0e9c43d632b99c␟4921558409600955887: Send `;
    } return [["aria-hidden", "false", "aria-label", "info", 1, "wtc-dialog-close-icon", 3, "click"], [1, "position-relative", "accept-offer"], [4, "ngIf"], ["align", "end"], [3, "ngClass", "click"], i18n_11, ["mat-button", "", "color", "primary", 3, "disabled", 4, "ngIf"], [1, "mb-3"], [1, "text-left"], i18n_13, i18n_15, ["novalidate", "", 1, "text-left", 3, "formGroup", "ngSubmit"], [1, "w-100"], i18n_17, ["type", "text", "name", "userName", "matInput", "", "formControlName", "name"], [1, "w-100", "mt-3"], i18n_19, ["formControlName", "email", "type", "text", "name", "email", "matInput", ""], i18n_21, ["formControlName", "ssn", "type", "tel", "name", "ssn", "matInput", ""], i18n_23, ["formControlName", "phone", "type", "tel", "name", "phone", "matInput", ""], i18n_25, i18n_27, i18n_29, i18n_31, i18n_33, i18n_35, i18n_37, i18n_39, ["mat-button", "", "color", "primary", 3, "disabled"], i18n_41]; }, template: function AcceptOfferDialogComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵelementStart(0, "mat-icon", 0);
        ɵngcc0.ɵɵlistener("click", function AcceptOfferDialogComponent_Template_mat_icon_click_0_listener() { return ctx.onNoClick(); });
        ɵngcc0.ɵɵtext(1, "close");
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(2, "mat-dialog-content", 1);
        ɵngcc0.ɵɵtemplate(3, AcceptOfferDialogComponent_ng_container_3_Template, 8, 1, "ng-container", 2);
        ɵngcc0.ɵɵtemplate(4, AcceptOfferDialogComponent_ng_container_4_Template, 26, 9, "ng-container", 2);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(5, "mat-dialog-actions", 3);
        ɵngcc0.ɵɵelementStart(6, "a", 4);
        ɵngcc0.ɵɵlistener("click", function AcceptOfferDialogComponent_Template_a_click_6_listener() { return ctx.onNoClick(); });
        ɵngcc0.ɵɵi18n(7, 5);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵtemplate(8, AcceptOfferDialogComponent_button_8_Template, 2, 1, "button", 6);
        ɵngcc0.ɵɵelementEnd();
    } if (rf & 2) {
        ɵngcc0.ɵɵadvance(3);
        ɵngcc0.ɵɵproperty("ngIf", ctx.isOfferAccepted);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("ngIf", !ctx.isOfferAccepted);
        ɵngcc0.ɵɵadvance(2);
        ɵngcc0.ɵɵproperty("ngClass", ɵngcc0.ɵɵpureFunction1(4, _c43, !ctx.isOfferAccepted));
        ɵngcc0.ɵɵadvance(2);
        ɵngcc0.ɵɵproperty("ngIf", !ctx.isOfferAccepted);
    } }, directives: [ɵngcc4.MatIcon, ɵngcc6.MatDialogContent, ɵngcc2.NgIf, ɵngcc6.MatDialogActions, ɵngcc2.NgClass, ɵngcc9.ɵangular_packages_forms_forms_y, ɵngcc9.NgControlStatusGroup, ɵngcc9.FormGroupDirective, ɵngcc11.MatFormField, ɵngcc11.MatLabel, ɵngcc12.MatInput, ɵngcc9.DefaultValueAccessor, ɵngcc9.NgControlStatus, ɵngcc9.FormControlName, ɵngcc11.MatError, ɵngcc10.MatButton], styles: [""] });
/** @nocollapse */
AcceptOfferDialogComponent.ctorParameters = () => [
    { type: MatDialogRef },
    { type: FormBuilder },
    { type: ConfigShared },
    { type: undefined, decorators: [{ type: Inject, args: [MAT_DIALOG_DATA,] }] }
];
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(AcceptOfferDialogComponent, [{
        type: Component,
        args: [{
                selector: 'wtc-shared-accept-offer-dialog',
                template: "<mat-icon\n  (click)=\"onNoClick()\"\n  class=\"wtc-dialog-close-icon\"\n  aria-hidden=\"false\" aria-label=\"info\">close</mat-icon>\n\n<mat-dialog-content\n  class=\"position-relative accept-offer\">\n\n  <ng-container *ngIf=\"isOfferAccepted\">\n    <header class=\"dialog__header\" class=\"mb-3\">\n      <h4 class=\"text-left\">\n        <span\n          i18n=\"Success page header@@success_page.header\">\n          Success!\n        </span>\n      </h4>\n      <p>\n        <span\n          i18n=\"Offer succes page description 1@@success_page.description_1\">\n          Dear {{data.clientName}}\n        </span>\n      </p>\n    </header>\n  </ng-container>\n\n  <ng-container *ngIf=\"!isOfferAccepted\">\n    <form\n      class=\"text-left\"\n      [formGroup]=\"acceptOfferForm\"\n      (ngSubmit)=\"acceptOffer(acceptOfferForm)\"\n      novalidate>\n  \n      <mat-form-field class=\"w-100\">\n        <mat-label i18n=\"Accept offer name@@accept_offer.name\">\n          Username\n        </mat-label>\n        <input\n          type=\"text\"\n          name=\"userName\"\n          matInput\n          formControlName=\"name\">\n      </mat-form-field>\n      <mat-error\n        *ngIf=\"acceptOfferForm.controls['name'].touched && acceptOfferForm.controls['name'].hasError('required')\"\n        i18n=\"Is required error@@form_validation.is_required\">\n          Field is required\n      </mat-error>\n      <mat-error\n        *ngIf=\"acceptOfferForm.controls['name'].touched && acceptOfferForm.controls['name'].hasError('pattern')\"\n        i18n=\"Name invalid error@@form_validation.name_invalid\">\n          Name invalid\n      </mat-error>\n  \n      <mat-form-field class=\"w-100 mt-3\">\n        <mat-label i18n=\"Accept offer email@@accept_offer.email\">\n          Email\n        </mat-label>\n        <input\n          formControlName=\"email\"\n          type=\"text\"\n          name=\"email\"\n          matInput>\n      </mat-form-field>\n      <mat-error\n        *ngIf=\"acceptOfferForm.controls['email'].touched && acceptOfferForm.controls['email'].hasError('required')\"\n        i18n=\"Is required error@@form_validation.is_required\">\n        Field is required\n      </mat-error>\n      <mat-error\n        *ngIf=\"acceptOfferForm.controls['email'].touched && acceptOfferForm.controls['email'].hasError('pattern')\"\n        i18n=\"Email invalid error@@form_validation.email_invalid\">\n        Email invalid\n      </mat-error>\n  \n      <mat-form-field class=\"w-100 mt-3\">\n        <mat-label i18n=\"Accept offer ssn@@accept_offer.ssn\">\n          Ssn\n        </mat-label>\n        <input\n          formControlName=\"ssn\"\n          type=\"tel\"\n          name=\"ssn\"\n          matInput>\n      </mat-form-field>\n      <mat-error\n        *ngIf=\"acceptOfferForm.controls['ssn'].touched && acceptOfferForm.controls['ssn'].hasError('required')\"\n        i18n=\"Is required error@@form_validation.is_required\">\n        Field is required\n      </mat-error>\n      <mat-error\n        *ngIf=\"acceptOfferForm.controls['ssn'].touched && acceptOfferForm.controls['ssn'].hasError('pattern')\"\n        i18n=\"Ssn invalid error@@form_validation.email_invalid\">\n        Ssn invalid\n      </mat-error>\n  \n      <mat-form-field class=\"w-100 mt-3\">\n        <mat-label i18n=\"Accept offer phone@@accept_offer.phone\">\n          Phone\n        </mat-label>\n        <input\n          formControlName=\"phone\"\n          type=\"tel\"\n          name=\"phone\"\n          matInput>\n      </mat-form-field>\n      <mat-error\n        *ngIf=\"acceptOfferForm.controls['phone'].touched && acceptOfferForm.controls['phone'].hasError('required')\"\n        i18n=\"Is required error@@form_validation.is_required\">\n        Field is required\n      </mat-error>\n      <mat-error\n        *ngIf=\"acceptOfferForm.controls['phone'].touched && acceptOfferForm.controls['phone'].hasError('pattern')\"\n        i18n=\"Phone invalid error@@form_validation.phone_invalid\">\n        Phone invalid\n      </mat-error>\n    </form>\n  </ng-container>\n</mat-dialog-content>\n\n<mat-dialog-actions align=\"end\">\n  <a\n    [ngClass]=\"{'mr-5': !isOfferAccepted}\"\n    (click)=\"onNoClick()\"\n    i18n=\"Accept offer close btn@@accept_offer.close_btn\">\n    Close\n  </a>\n  <button\n    *ngIf=\"!isOfferAccepted\"\n    mat-button\n    color=\"primary\"\n    [disabled]=\"acceptOfferForm.invalid || successDataLoader\"\n    i18n=\"Accept offer success btn@@accept_offer.success_btn\">\n    Send\n  </button>\n</mat-dialog-actions>",
                styles: [""]
            }]
    }], function () { return [{ type: ɵngcc6.MatDialogRef }, { type: ɵngcc9.FormBuilder }, { type: ConfigShared }, { type: undefined, decorators: [{
                type: Inject,
                args: [MAT_DIALOG_DATA]
            }] }]; }, null); })();

class OfferViewComponent {
    constructor(config, dialog, profileService) {
        this.config = config;
        this.dialog = dialog;
        this.profileService = profileService;
        this.originalSize = false;
        this.openFullScreen = false;
    }
    ngOnInit() {
    }
    openFullSizeDialog() {
        this.openFullScreen = true;
        const dialogRef = this.dialog.open(PdfViewDialogComponent, {
            width: '100%',
            height: '90%',
            data: {
                documentUrl: this.offerData.documentUrl,
                documentName: this.offerData.documentName,
                documentStatus: this.offerData.status,
                listenScrollBottomEvent: true
            },
            panelClass: ['wtc-dialog', 'pdf-full-size']
        });
        dialogRef.afterClosed().subscribe(data => {
            if (data) {
                this.openFullScreen = false;
            }
        });
    }
    onFileChange(event) {
        this.offerData.documentUrl = event;
    }
}
OfferViewComponent.ɵfac = function OfferViewComponent_Factory(t) { return new (t || OfferViewComponent)(ɵngcc0.ɵɵdirectiveInject(ConfigShared), ɵngcc0.ɵɵdirectiveInject(ɵngcc6.MatDialog), ɵngcc0.ɵɵdirectiveInject(ProfileService)); };
OfferViewComponent.ɵcmp = ɵngcc0.ɵɵdefineComponent({ type: OfferViewComponent, selectors: [["wtc-shared-offer-view"]], inputs: { offerData: "offerData" }, decls: 1, vars: 1, consts: function () { let i18n_44; if (typeof ngI18nClosureMode !== "undefined" && ngI18nClosureMode) {
        /**
         * @desc Offer full screen btn text
         */
        const MSG_EXTERNAL_offer_full_screen_btn_text$$FESM2015_WTC_SHARED_JS__45 = goog.getMsg(" Full screen ");
        i18n_44 = MSG_EXTERNAL_offer_full_screen_btn_text$$FESM2015_WTC_SHARED_JS__45;
    }
    else {
        i18n_44 = $localize `:Offer full screen btn text@@offer.full_screen_btn_text␟45a34aedcc43813455c37c1be5d0cd52f5775880␟6396465948414642931: Full screen `;
    } let i18n_46; if (typeof ngI18nClosureMode !== "undefined" && ngI18nClosureMode) {
        /**
         * @desc Offer download doc
         */
        const MSG_EXTERNAL_offer_download_doc$$FESM2015_WTC_SHARED_JS__47 = goog.getMsg(" Download ");
        i18n_46 = MSG_EXTERNAL_offer_download_doc$$FESM2015_WTC_SHARED_JS__47;
    }
    else {
        i18n_46 = $localize `:Offer download doc@@offer.download_doc␟28bf49a8a90289c034b2970031814f8164f9e02d␟2864562369492427846: Download `;
    } return [["class", "position-relative", 4, "ngIf"], [1, "position-relative"], [1, "pdf-viewer-box"], ["id", "pdfViewer", 3, "src", "textLayer", "mobileFriendlyZoom", "maxZoom", "enablePinchOnMobile", "handTool", "showToolbar", "backgroundColor", "pdfLoaded", 4, "ngIf"], [1, "text-center", "mt-3", "full-size-block"], [3, "ngClass", "click"], ["aria-hidden", "false", "aria-label", "info"], i18n_44, [1, "ml-4", 3, "ngClass", "click"], i18n_46, ["id", "pdfViewer", 3, "src", "textLayer", "mobileFriendlyZoom", "maxZoom", "enablePinchOnMobile", "handTool", "showToolbar", "backgroundColor", "pdfLoaded"]]; }, template: function OfferViewComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵtemplate(0, OfferViewComponent_div_0_Template, 14, 7, "div", 0);
    } if (rf & 2) {
        ɵngcc0.ɵɵproperty("ngIf", ctx.offerData && ctx.offerData.documentUrl);
    } }, directives: [ɵngcc2.NgIf, ɵngcc2.NgClass, ɵngcc4.MatIcon, ɵngcc7.NgxExtendedPdfViewerComponent], styles: [""] });
/** @nocollapse */
OfferViewComponent.ctorParameters = () => [
    { type: ConfigShared },
    { type: MatDialog },
    { type: ProfileService }
];
OfferViewComponent.propDecorators = {
    offerData: [{ type: Input }]
};
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(OfferViewComponent, [{
        type: Component,
        args: [{
                selector: 'wtc-shared-offer-view',
                template: "<div class=\"position-relative\" *ngIf=\"offerData && offerData.documentUrl\">\n  <div class=\"pdf-viewer-box\">\n    <ngx-extended-pdf-viewer\n      *ngIf=\"!openFullScreen\"\n      id=\"pdfViewer\"\n      [src]=\"offerData.documentUrl\"\n      [textLayer]=\"false\"\n      [mobileFriendlyZoom]=\"'150%'\"\n      [maxZoom]=\"7\"\n      [enablePinchOnMobile]=\"true\"\n      [handTool]=\"false\"\n      [showToolbar]=\"false\"\n      [backgroundColor]=\"'#fff'\"\n      (pdfLoaded)=\"profileService.pdfViewerLoaded()\">\n    </ngx-extended-pdf-viewer>\n  </div>\n\n  <div class=\"text-center mt-3 full-size-block\">\n    <a (click)=\"openFullSizeDialog()\" [ngClass]=\"config.brandConfig.styles.offerActionClass\">\n      <mat-icon [class]=\"'mr-1 ' + config.brandConfig.styles.actionIconsClass\" aria-hidden=\"false\" aria-label=\"info\">crop_free</mat-icon>\n      <span i18n=\"Offer full screen btn text@@offer.full_screen_btn_text\">\n        Full screen\n      </span>\n    </a>\n\n    <a\n      (click)=\"profileService.downloadPdf(offerData.documentUrl, offerData.documentName)\"\n      [ngClass]=\"config.brandConfig.styles.offerActionClass\"\n      class=\"ml-4\">\n      <mat-icon [class]=\"'mr-1 ' + config.brandConfig.styles.actionIconsClass\" aria-hidden=\"false\" aria-label=\"info\">get_app</mat-icon>\n      <span i18n=\"Offer download doc@@offer.download_doc\">\n        Download\n      </span>\n    </a>\n  </div>\n</div>\n",
                styles: [""]
            }]
    }], function () { return [{ type: ConfigShared }, { type: ɵngcc6.MatDialog }, { type: ProfileService }]; }, { offerData: [{
            type: Input
        }] }); })();

class OfferActionsComponent {
    constructor(profileService, dialog, config, profileApiService, messageService, router, route) {
        this.profileService = profileService;
        this.dialog = dialog;
        this.config = config;
        this.profileApiService = profileApiService;
        this.messageService = messageService;
        this.router = router;
        this.route = route;
        this.offerLoader = false;
        this.paramsOfferId = '';
        this.msgText = '';
        this.msgType = '';
        this.offerStatuses = OFFER_STATUSES;
        this.offerAcceptStatusLoader = false;
        this.offerDeclineStatusLoader = false;
    }
    ngOnInit() {
        this.routeParamsSub = this.route.params.subscribe((params) => {
            this.handleRouteParams(params);
        });
    }
    ngOnDestroy() {
        if (this.routeParamsSub) {
            this.routeParamsSub.unsubscribe();
        }
    }
    navigateToMyPage() {
        this.router.navigate([this.config.pages.profile, this.config.pages.profileInfo], {
            queryParamsHandling: 'merge',
        });
    }
    acceptOffer() {
        const dataToSend = {
            status: this.offerStatuses.ACCEPT
        };
        this.offerAcceptStatusLoader = true;
        this.profileApiService.setOfferStatus(this.offerData.id, dataToSend).subscribe(res => {
            this.offerAcceptStatusLoader = false;
            this.offerData.status = this.offerStatuses.ACCEPT;
            this.openAcceptOfferDialog();
        }, err => {
            this.offerAcceptStatusLoader = false;
            this.messageService.showGlobalMessage(err);
        });
    }
    declineOffer(reason = '') {
        const dataToSend = {
            status: this.offerStatuses.DECLINE,
            rejection: reason
        };
        this.offerDeclineStatusLoader = true;
        this.profileApiService.setOfferStatus(this.offerData.id, dataToSend).subscribe(res => {
            this.offerDeclineStatusLoader = false;
            this.offerData.status = this.offerStatuses.DECLINE;
        }, err => {
            this.offerDeclineStatusLoader = false;
            this.messageService.showGlobalMessage(err);
        });
    }
    openAcceptOfferDialog() {
        const dialogRef = this.dialog.open(AcceptOfferDialogComponent, {
            width: '460px',
            data: { clientName: this.offerData.firstName },
            panelClass: ['wtc-dialog', 'light-panel']
        });
        dialogRef.afterClosed().subscribe(result => {
            console.log('The dialog was closed');
        });
    }
    openDeclineOfferDialog() {
        const dialogRef = this.dialog.open(DeclineOfferDialogComponent, {
            width: '460px',
            data: {},
            panelClass: ['wtc-dialog']
        });
        dialogRef.afterClosed().subscribe(data => {
            if (data && data.isOfferDeclined) {
                this.declineOffer(data.reason);
            }
        });
    }
    handleRouteParams(params) {
        if (params.offerId) {
            this.profileService.isPdfReaded = false;
            this.profileService.offerListData = undefined;
            this.paramsOfferId = params.offerId;
            this.fetchOfferDataById();
        }
        else {
            this.offerData = this.profileService.offerData;
        }
    }
    fetchOfferDataById() {
        this.offerLoader = true;
        this.msgText = '';
        this.msgType = '';
        this.profileApiService.getOfferById(this.paramsOfferId).subscribe(res => {
            this.offerLoader = false;
            this.offerData = res;
        }, err => {
            this.offerLoader = false;
            [this.msgText, this.msgType] =
                this.messageService.parseError(err);
        });
    }
}
OfferActionsComponent.ɵfac = function OfferActionsComponent_Factory(t) { return new (t || OfferActionsComponent)(ɵngcc0.ɵɵdirectiveInject(ProfileService), ɵngcc0.ɵɵdirectiveInject(ɵngcc6.MatDialog), ɵngcc0.ɵɵdirectiveInject(ConfigShared), ɵngcc0.ɵɵdirectiveInject(ProfileApiService), ɵngcc0.ɵɵdirectiveInject(MessageService), ɵngcc0.ɵɵdirectiveInject(ɵngcc13.Router), ɵngcc0.ɵɵdirectiveInject(ɵngcc13.ActivatedRoute)); };
OfferActionsComponent.ɵcmp = ɵngcc0.ɵɵdefineComponent({ type: OfferActionsComponent, selectors: [["wtc-shared-offer-actions"]], decls: 3, vars: 4, consts: function () { let i18n_48; if (typeof ngI18nClosureMode !== "undefined" && ngI18nClosureMode) {
        /**
         * @desc Offer my page btn
         */
        const MSG_EXTERNAL_offer_my_page_btn$$FESM2015_WTC_SHARED_JS__49 = goog.getMsg("Go to my page");
        i18n_48 = MSG_EXTERNAL_offer_my_page_btn$$FESM2015_WTC_SHARED_JS__49;
    }
    else {
        i18n_48 = $localize `:Offer my page btn@@offer.my_page_btn␟7dd093baf9c97de6277ce1da78a8b632cb0e2dcc␟7291426596212882826:Go to my page`;
    } let i18n_50; if (typeof ngI18nClosureMode !== "undefined" && ngI18nClosureMode) {
        /**
         * @desc Offer accept notification
         */
        const MSG_EXTERNAL_offer_accept_doc_notification$$FESM2015_WTC_SHARED_JS___51 = goog.getMsg("Read offer till the end for accept or decline");
        i18n_50 = MSG_EXTERNAL_offer_accept_doc_notification$$FESM2015_WTC_SHARED_JS___51;
    }
    else {
        i18n_50 = $localize `:Offer accept notification@@offer.accept_doc_notification␟fcee66d428782ffa3824f28e62cbe4fabed331b3␟4864259092368035659:Read offer till the end for accept or decline`;
    } let i18n_52; if (typeof ngI18nClosureMode !== "undefined" && ngI18nClosureMode) {
        /**
         * @desc Offer aceept doc
         */
        const MSG_EXTERNAL_offer_accept_doc$$FESM2015_WTC_SHARED_JS___53 = goog.getMsg(" Accept offer ");
        i18n_52 = MSG_EXTERNAL_offer_accept_doc$$FESM2015_WTC_SHARED_JS___53;
    }
    else {
        i18n_52 = $localize `:Offer aceept doc@@offer.accept_doc␟8360f608db42e18a88fbb69629908c2f9952cecd␟2476931806558697635: Accept offer `;
    } let i18n_54; if (typeof ngI18nClosureMode !== "undefined" && ngI18nClosureMode) {
        /**
         * @desc Offer accepted btn text
         */
        const MSG_EXTERNAL_offer_accepted_btn_text$$FESM2015_WTC_SHARED_JS___55 = goog.getMsg(" Offer accepted ");
        i18n_54 = MSG_EXTERNAL_offer_accepted_btn_text$$FESM2015_WTC_SHARED_JS___55;
    }
    else {
        i18n_54 = $localize `:Offer accepted btn text@@offer.accepted_btn_text␟a656690bd07652ca97e900c4cd56a5f96f6d8467␟5035392188650933385: Offer accepted `;
    } let i18n_56; if (typeof ngI18nClosureMode !== "undefined" && ngI18nClosureMode) {
        /**
         * @desc Offer declined btn text
         */
        const MSG_EXTERNAL_offer_declined_btn_text$$FESM2015_WTC_SHARED_JS___57 = goog.getMsg(" Offer declined ");
        i18n_56 = MSG_EXTERNAL_offer_declined_btn_text$$FESM2015_WTC_SHARED_JS___57;
    }
    else {
        i18n_56 = $localize `:Offer declined btn text@@offer.declined_btn_text␟94e0db3dfcc6ba362bfcdeb4754c6ebe8e50b52d␟1193886371597320911: Offer declined `;
    } let i18n_58; if (typeof ngI18nClosureMode !== "undefined" && ngI18nClosureMode) {
        /**
         * @desc Offer decline doc
         */
        const MSG_EXTERNAL_offer_decline_doc$$FESM2015_WTC_SHARED_JS___59 = goog.getMsg(" Decline offer ");
        i18n_58 = MSG_EXTERNAL_offer_decline_doc$$FESM2015_WTC_SHARED_JS___59;
    }
    else {
        i18n_58 = $localize `:Offer decline doc@@offer.decline_doc␟7571df174041e90ff820e5f043ca5b8409c39e95␟8523803119214592949: Decline offer `;
    } return [[4, "ngIf"], ["class", "text-center mt-5", 4, "ngIf"], [1, "text-center", "d-block", "mt-5", "margin-auto", 3, "message", "type"], ["mat-button", "", 1, "mt-md-4", 3, "color", "ngClass", "click"], i18n_48, [1, "d-block", "mt-2", "mt-md-5", 3, "offerData"], ["class", "opacity--light font-size-small mb-3", 4, "ngIf"], ["mat-button", "", 1, "mb-3", "btn-mobile-block", 3, "color", "ngClass", "disabled", "click"], ["class", "d-inline-block mr-1", "diameter", "24", "color", "accent", 4, "ngIf"], ["class", "mr-2 btn-icon", "aria-hidden", "false", "aria-label", "info", 4, "ngIf"], ["class", "d-inline-flex margin-auto", 3, "ngClass", "click", 4, "ngIf"], [1, "opacity--light", "font-size-small", "mb-3"], i18n_50, ["diameter", "24", "color", "accent", 1, "d-inline-block", "mr-1"], ["aria-hidden", "false", "aria-label", "info", 1, "mr-2", "btn-icon"], i18n_52, i18n_54, i18n_56, [1, "d-inline-flex", "margin-auto", 3, "ngClass", "click"], i18n_58, [1, "text-center", "mt-5"], [1, "margin-auto"]]; }, template: function OfferActionsComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵtemplate(0, OfferActionsComponent_ng_container_0_Template, 14, 15, "ng-container", 0);
        ɵngcc0.ɵɵtemplate(1, OfferActionsComponent_div_1_Template, 2, 0, "div", 1);
        ɵngcc0.ɵɵelement(2, "wtc-shared-messages", 2);
    } if (rf & 2) {
        ɵngcc0.ɵɵproperty("ngIf", ctx.offerData);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("ngIf", ctx.offerLoader);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("message", ctx.msgText)("type", ctx.msgType);
    } }, directives: [ɵngcc2.NgIf, MessagesComponent, ɵngcc10.MatButton, ɵngcc2.NgClass, OfferViewComponent, ɵngcc14.MatSpinner, ɵngcc4.MatIcon], encapsulation: 2 });
/** @nocollapse */
OfferActionsComponent.ctorParameters = () => [
    { type: ProfileService },
    { type: MatDialog },
    { type: ConfigShared },
    { type: ProfileApiService },
    { type: MessageService },
    { type: Router },
    { type: ActivatedRoute }
];
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(OfferActionsComponent, [{
        type: Component,
        args: [{
                selector: 'wtc-shared-offer-actions',
                template: "<ng-container *ngIf=\"offerData\">\n  <button\n    mat-button\n    [color]=\"config.brandConfig.styles.offerPageButtonType\"\n    class=\"mt-md-4\"\n    [ngClass]=\"config.brandConfig.styles.offerPageButtonClass\"\n    (click)=\"navigateToMyPage()\"\n    i18n=\"Offer my page btn@@offer.my_page_btn\">Go to my page</button>\n\n  <wtc-shared-offer-view\n    class=\"d-block mt-2 mt-md-5\"\n    [offerData]=\"offerData\"></wtc-shared-offer-view>\n  <div [class]=\"config.brandConfig.styles.actionsBlockClass\">\n    <div\n      *ngIf=\"!offerData.status\"\n      i18n=\"Offer accept notification@@offer.accept_doc_notification\"\n      class=\"opacity--light font-size-small mb-3\">Read offer till the end for accept or decline</div>\n    <div>\n      <button\n        class=\"mb-3 btn-mobile-block\"\n        mat-button\n        [color]=\"config.brandConfig.styles.offerPageButtonType\"\n        [ngClass]=\"config.brandConfig.styles.offerPageButtonClass\"\n        [disabled]=\"offerAcceptStatusLoader || offerDeclineStatusLoader || offerData.status || !profileService.isPdfReaded\"\n        (click)=\"acceptOffer()\">\n        <mat-spinner\n          *ngIf=\"offerAcceptStatusLoader\"\n          class=\"d-inline-block mr-1\"\n          diameter=\"24\"\n          color=\"accent\"></mat-spinner>\n        <mat-icon\n          *ngIf=\"offerData.status\"\n          class=\"mr-2 btn-icon\"\n          aria-hidden=\"false\" aria-label=\"info\">done</mat-icon>\n\n        <span *ngIf=\"!offerData.status\"\n          i18n=\"Offer aceept doc@@offer.accept_doc\">\n          Accept offer\n        </span>\n        <span *ngIf=\"offerData.status === offerStatuses.ACCEPT\"\n          i18n=\"Offer accepted btn text@@offer.accepted_btn_text\">\n          Offer accepted\n        </span>\n        <span *ngIf=\"offerData.status === offerStatuses.DECLINE\"\n          i18n=\"Offer declined btn text@@offer.declined_btn_text\">\n          Offer declined\n        </span>\n      </button>\n    </div>\n    <a\n      *ngIf=\"!offerData.status\"\n      class=\"d-inline-flex margin-auto\"\n      [ngClass]=\"{'disabled': offerAcceptStatusLoader || offerDeclineStatusLoader || !profileService.isPdfReaded}\"\n      (click)=\"openDeclineOfferDialog()\">\n      <mat-spinner\n        *ngIf=\"offerDeclineStatusLoader\"\n        class=\"d-inline-block mr-1\"\n        diameter=\"24\"\n        color=\"accent\"></mat-spinner>\n      <span i18n=\"Offer decline doc@@offer.decline_doc\">\n        Decline offer\n      </span>\n    </a>\n  </div>\n</ng-container>\n\n<div class=\"text-center mt-5\" *ngIf=\"offerLoader\">\n  <mat-spinner class=\"margin-auto\"></mat-spinner>\n</div>\n\n<wtc-shared-messages\n  class=\"text-center d-block mt-5 margin-auto\"\n  [message]=\"msgText\"\n  [type]=\"msgType\"></wtc-shared-messages>\n"
            }]
    }], function () { return [{ type: ProfileService }, { type: ɵngcc6.MatDialog }, { type: ConfigShared }, { type: ProfileApiService }, { type: MessageService }, { type: ɵngcc13.Router }, { type: ɵngcc13.ActivatedRoute }]; }, null); })();

class ProfileTabsComponent {
    constructor(profileService, dialog, config, i18n, messageService, router) {
        this.profileService = profileService;
        this.dialog = dialog;
        this.config = config;
        this.i18n = i18n;
        this.messageService = messageService;
        this.router = router;
        this.actionIconsClass = 'text-primary';
        this.msgText = '';
        this.msgType = '';
        this.documentsLoader = false;
        this.offerStatuses = OFFER_STATUSES;
    }
    ngOnInit() {
    }
    getLables(labelType) {
        return this.i18n({ value: labelType, id: `profile_info.${labelType}`, meaning: labelType });
    }
    tabChange(tabIndex) {
        if (tabIndex === 1) {
            this.fetchDocuments();
        }
    }
    handleOfferActions(documentData) {
        if (!documentData.status) {
            this.router.navigate([this.config.pages.profile, documentData.id], {
                queryParamsHandling: 'merge'
            });
        }
        else {
            this.watchPdf(documentData);
        }
    }
    watchPdf(documentData) {
        this.dialog.open(PdfViewDialogComponent, {
            width: '100%',
            height: '90%',
            data: {
                documentUrl: documentData.documentUrl,
                documentName: documentData.documentName,
                documentStatus: documentData.status,
                listenScrollBottomEvent: false
            },
            panelClass: ['wtc-dialog', 'pdf-full-size']
        });
    }
    fetchDocuments() {
        this.documentsLoader = true;
        this.documents = undefined;
        this.profileService.getOfferListData().subscribe(res => {
            this.documentsLoader = false;
            this.documents = res.filter((document) => document.documentName && document.documentUrl);
        }, err => {
            this.documentsLoader = false;
            [this.msgText, this.msgType] =
                this.messageService.parseError(err);
        });
    }
}
ProfileTabsComponent.ɵfac = function ProfileTabsComponent_Factory(t) { return new (t || ProfileTabsComponent)(ɵngcc0.ɵɵdirectiveInject(ProfileService), ɵngcc0.ɵɵdirectiveInject(ɵngcc6.MatDialog), ɵngcc0.ɵɵdirectiveInject(ConfigShared), ɵngcc0.ɵɵdirectiveInject(ɵngcc8.I18n), ɵngcc0.ɵɵdirectiveInject(MessageService), ɵngcc0.ɵɵdirectiveInject(ɵngcc13.Router)); };
ProfileTabsComponent.ɵcmp = ɵngcc0.ɵɵdefineComponent({ type: ProfileTabsComponent, selectors: [["wtc-shared-profile-tabs"]], inputs: { actionIconsClass: "actionIconsClass" }, decls: 31, vars: 8, consts: function () { let i18n_61; if (typeof ngI18nClosureMode !== "undefined" && ngI18nClosureMode) {
        /**
         * @desc Profile info email
         */
        const MSG_EXTERNAL_profile_info_email$$FESM2015_WTC_SHARED_JS_62 = goog.getMsg("Email: ");
        i18n_61 = MSG_EXTERNAL_profile_info_email$$FESM2015_WTC_SHARED_JS_62;
    }
    else {
        i18n_61 = $localize `:Profile info email@@profile_info.email␟75f05dbf6d6ecf705b1f36a5da54bc1f788f1d25␟6019286882116423552:Email: `;
    } let i18n_63; if (typeof ngI18nClosureMode !== "undefined" && ngI18nClosureMode) {
        /**
         * @desc Profile info phone
         */
        const MSG_EXTERNAL_profile_info_phone$$FESM2015_WTC_SHARED_JS_64 = goog.getMsg("Phone: ");
        i18n_63 = MSG_EXTERNAL_profile_info_phone$$FESM2015_WTC_SHARED_JS_64;
    }
    else {
        i18n_63 = $localize `:Profile info phone@@profile_info.phone␟f00aa029732e017915b48c95328a906dfad54cd9␟962072755979883714:Phone: `;
    } let i18n_65; if (typeof ngI18nClosureMode !== "undefined" && ngI18nClosureMode) {
        /**
         * @desc Profile info ssn
         */
        const MSG_EXTERNAL_profile_info_ssn$$FESM2015_WTC_SHARED_JS_66 = goog.getMsg("Ssn:");
        i18n_65 = MSG_EXTERNAL_profile_info_ssn$$FESM2015_WTC_SHARED_JS_66;
    }
    else {
        i18n_65 = $localize `:Profile info ssn@@profile_info.ssn␟2c62a7dbebfd5fd9c32eee9f376e0291233f187a␟701718607952826350:Ssn:`;
    } let i18n_67; if (typeof ngI18nClosureMode !== "undefined" && ngI18nClosureMode) {
        /**
         * @desc Offers title
         */
        const MSG_EXTERNAL_profile_info_offers_title$$FESM2015_WTC_SHARED_JS__68 = goog.getMsg("Offers");
        i18n_67 = MSG_EXTERNAL_profile_info_offers_title$$FESM2015_WTC_SHARED_JS__68;
    }
    else {
        i18n_67 = $localize `:Offers title@@profile_info.offers_title␟d1eae8c113c30c7e9efa550a893e263b855dffe9␟7668600654612737658:Offers`;
    } let i18n_69; if (typeof ngI18nClosureMode !== "undefined" && ngI18nClosureMode) {
        /**
         * @desc Documents pending status
         */
        const MSG_EXTERNAL_documents_status_pending$$FESM2015_WTC_SHARED_JS____70 = goog.getMsg(" Pending ");
        i18n_69 = MSG_EXTERNAL_documents_status_pending$$FESM2015_WTC_SHARED_JS____70;
    }
    else {
        i18n_69 = $localize `:Documents pending status@@documents.status.pending␟1a5e879b9c66e649598916f19f465c422dbbb816␟6619624037268856168: Pending `;
    } let i18n_71; if (typeof ngI18nClosureMode !== "undefined" && ngI18nClosureMode) {
        /**
         * @desc Documents accepted status
         */
        const MSG_EXTERNAL_documents_status_accepted$$FESM2015_WTC_SHARED_JS____72 = goog.getMsg(" Accepted ");
        i18n_71 = MSG_EXTERNAL_documents_status_accepted$$FESM2015_WTC_SHARED_JS____72;
    }
    else {
        i18n_71 = $localize `:Documents accepted status@@documents.status.accepted␟21f585b8e8c19ffd64d5cdbb265d5ea08b7514cd␟607885095638954273: Accepted `;
    } let i18n_73; if (typeof ngI18nClosureMode !== "undefined" && ngI18nClosureMode) {
        /**
         * @desc Documents declined status
         */
        const MSG_EXTERNAL_documents_status_declined$$FESM2015_WTC_SHARED_JS____74 = goog.getMsg(" Declined ");
        i18n_73 = MSG_EXTERNAL_documents_status_declined$$FESM2015_WTC_SHARED_JS____74;
    }
    else {
        i18n_73 = $localize `:Documents declined status@@documents.status.declined␟4997ee4ba3a7bb809198689c9a12f0140584e7a8␟917500734621544279: Declined `;
    } return [[1, "card-profile-tabs", "mt-4", 3, "ngClass"], ["animationDuration", "0ms", 3, "selectedTabChange"], ["mat-tab-label", ""], [1, "mt-4", "card-profile-list"], ["mat-list-icon", "", 1, "opacity--light"], ["mat-line", "", 1, "font-size-small", "opacity--light"], i18n_61, ["mat-line", ""], i18n_63, i18n_65, ["class", "text-center mt-5", 4, "ngIf"], ["class", "documents-list-wrap", 4, "ngIf"], [1, "text-center", "d-block", "mt-3", "margin-auto", 3, "message", "type"], [3, "ngClass"], [1, "text-center", "mt-5"], [1, "margin-auto", 3, "color"], [1, "documents-list-wrap"], [1, "offer-profile-list"], [1, "mt-4", "ml-3", "mb-2"], i18n_67, ["class", "document-item bg-white", 4, "ngFor", "ngForOf"], [1, "document-item", "bg-white"], ["mat-line", "", 1, "font-size-middle", "d-inline-flex"], ["class", "opacity--light", 4, "ngIf"], ["class", "text-positive d-inline-flex", 4, "ngIf"], ["class", "text-negative d-inline-flex", 4, "ngIf"], [1, "opacity--light", "ml-2"], ["aria-hidden", "false", "aria-label", "info", "inline", "true", 3, "click"], [1, "opacity--light"], i18n_69, [1, "text-positive", "d-inline-flex"], ["aria-hidden", "false", "aria-label", "info", "inline", "true", 1, "font-size-middle", "mr-1"], i18n_71, [1, "text-negative", "d-inline-flex"], i18n_73]; }, template: function ProfileTabsComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵelementStart(0, "div", 0);
        ɵngcc0.ɵɵelementStart(1, "mat-tab-group", 1);
        ɵngcc0.ɵɵlistener("selectedTabChange", function ProfileTabsComponent_Template_mat_tab_group_selectedTabChange_1_listener($event) { return ctx.tabChange($event.index); });
        ɵngcc0.ɵɵelementStart(2, "mat-tab");
        ɵngcc0.ɵɵtemplate(3, ProfileTabsComponent_ng_template_3_Template, 2, 2, "ng-template", 2);
        ɵngcc0.ɵɵelementStart(4, "mat-list", 3);
        ɵngcc0.ɵɵelementStart(5, "mat-list-item");
        ɵngcc0.ɵɵelementStart(6, "mat-icon", 4);
        ɵngcc0.ɵɵtext(7, "email");
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(8, "div", 5);
        ɵngcc0.ɵɵi18n(9, 6);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(10, "div", 7);
        ɵngcc0.ɵɵtext(11);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(12, "mat-list-item");
        ɵngcc0.ɵɵelementStart(13, "mat-icon", 4);
        ɵngcc0.ɵɵtext(14, "ring_volume");
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(15, "div", 5);
        ɵngcc0.ɵɵi18n(16, 8);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(17, "div", 7);
        ɵngcc0.ɵɵtext(18);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(19, "mat-list-item");
        ɵngcc0.ɵɵelementStart(20, "mat-icon", 4);
        ɵngcc0.ɵɵtext(21, "assignment_ind");
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(22, "div", 5);
        ɵngcc0.ɵɵi18n(23, 9);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(24, "div", 7);
        ɵngcc0.ɵɵtext(25);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(26, "mat-tab");
        ɵngcc0.ɵɵtemplate(27, ProfileTabsComponent_ng_template_27_Template, 2, 2, "ng-template", 2);
        ɵngcc0.ɵɵtemplate(28, ProfileTabsComponent_div_28_Template, 2, 1, "div", 10);
        ɵngcc0.ɵɵtemplate(29, ProfileTabsComponent_div_29_Template, 5, 1, "div", 11);
        ɵngcc0.ɵɵelement(30, "wtc-shared-messages", 12);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
    } if (rf & 2) {
        ɵngcc0.ɵɵproperty("ngClass", ctx.config.brandConfig.styles.tabsColor);
        ɵngcc0.ɵɵadvance(11);
        ɵngcc0.ɵɵtextInterpolate1(" ", ctx.profileService.offerData.email, " ");
        ɵngcc0.ɵɵadvance(7);
        ɵngcc0.ɵɵtextInterpolate1(" ", ctx.profileService.offerData.phone, " ");
        ɵngcc0.ɵɵadvance(7);
        ɵngcc0.ɵɵtextInterpolate1(" ", ctx.profileService.offerData.ssn, " ");
        ɵngcc0.ɵɵadvance(3);
        ɵngcc0.ɵɵproperty("ngIf", ctx.documentsLoader);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("ngIf", !ctx.documentsLoader);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("message", ctx.msgText)("type", ctx.msgType);
    } }, directives: [ɵngcc2.NgClass, ɵngcc15.MatTabGroup, ɵngcc15.MatTab, ɵngcc15.MatTabLabel, ɵngcc16.MatList, ɵngcc16.MatListItem, ɵngcc4.MatIcon, ɵngcc16.MatListIconCssMatStyler, ɵngcc17.MatLine, ɵngcc2.NgIf, MessagesComponent, ɵngcc14.MatSpinner, ɵngcc2.NgForOf], pipes: [ɵngcc2.DatePipe], encapsulation: 2 });
/** @nocollapse */
ProfileTabsComponent.ctorParameters = () => [
    { type: ProfileService },
    { type: MatDialog },
    { type: ConfigShared },
    { type: I18n },
    { type: MessageService },
    { type: Router }
];
ProfileTabsComponent.propDecorators = {
    actionIconsClass: [{ type: Input }]
};
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(ProfileTabsComponent, [{
        type: Component,
        args: [{
                selector: 'wtc-shared-profile-tabs',
                template: "<div class=\"card-profile-tabs mt-4\" [ngClass]=\"config.brandConfig.styles.tabsColor\">\n  <mat-tab-group (selectedTabChange)=\"tabChange($event.index)\" animationDuration=\"0ms\">\n    <mat-tab>\n      <ng-template mat-tab-label>\n        <span [ngClass]=\"config.brandConfig.styles.tabsColor\">{{getLables('profile_label')}}</span>\n      </ng-template>\n      <mat-list class=\"mt-4 card-profile-list\">\n        <mat-list-item>\n          <mat-icon class=\"opacity--light\" mat-list-icon>email</mat-icon>\n          <div class=\"font-size-small opacity--light\" i18n=\"Profile info email@@profile_info.email\" mat-line>Email:\n          </div>\n          <div mat-line> {{profileService.offerData.email}} </div>\n        </mat-list-item>\n\n        <mat-list-item>\n          <mat-icon class=\"opacity--light\" mat-list-icon>ring_volume</mat-icon>\n          <div class=\"font-size-small opacity--light\" i18n=\"Profile info phone@@profile_info.phone\" mat-line>Phone:\n          </div>\n          <div mat-line> {{profileService.offerData.phone}} </div>\n        </mat-list-item>\n\n        <mat-list-item>\n          <mat-icon class=\"opacity--light\" mat-list-icon>assignment_ind</mat-icon>\n          <div class=\"font-size-small opacity--light\" i18n=\"Profile info ssn@@profile_info.ssn\" mat-line>Ssn:</div>\n          <div mat-line> {{profileService.offerData.ssn}} </div>\n        </mat-list-item>\n      </mat-list>\n    </mat-tab>\n    <mat-tab>\n      <ng-template mat-tab-label>\n        <span [ngClass]=\"config.brandConfig.styles.tabsColor\">{{getLables('documents_label')}}</span>\n      </ng-template>\n      <div *ngIf=\"documentsLoader\" class=\"text-center mt-5\">\n        <mat-spinner class=\"margin-auto\" color=\"{{config.brandConfig.styles.spinnerColor}}\"></mat-spinner>\n      </div>\n\n      <div *ngIf=\"!documentsLoader\" class=\"documents-list-wrap\">\n        <mat-list class=\"offer-profile-list\">\n          <h5 class=\"mt-4 ml-3 mb-2\" i18n=\"Offers title@@profile_info.offers_title\">Offers</h5>\n          <mat-list-item\n            *ngFor=\"let document of documents\"\n            class=\"document-item bg-white\">\n            <div mat-line>{{document.documentName}}</div>\n            <div class=\"font-size-middle d-inline-flex\" mat-line>\n              <span\n                *ngIf=\"!document.status\"\n                class=\"opacity--light\"\n                i18n=\"Documents pending status@@documents.status.pending\">\n                Pending\n              </span>\n              <span *ngIf=\"document.status === offerStatuses.ACCEPT\" class=\"text-positive d-inline-flex\">\n                <mat-icon\n                  aria-hidden=\"false\"\n                  aria-label=\"info\"\n                  class=\"font-size-middle mr-1\" inline=\"true\">done</mat-icon>\n                <span\n                  i18n=\"Documents accepted status@@documents.status.accepted\">\n                  Accepted\n                </span>\n              </span>\n\n              <span *ngIf=\"document.status === offerStatuses.DECLINE\" class=\"text-negative d-inline-flex\">\n                <mat-icon\n                  aria-hidden=\"false\"\n                  aria-label=\"info\"\n                  class=\"font-size-middle mr-1\" inline=\"true\">close</mat-icon>\n                <span\n                  i18n=\"Documents declined status@@documents.status.declined\">\n                  Declined\n                </span>\n              </span>\n\n              <span class=\"opacity--light ml-2\">\n                {{document.created | date: 'dd.MM.yyyy' }}\n              </span>\n\n              <mat-icon\n                (click)=\"handleOfferActions(document)\"\n                [class]=\"'download-documents-arrow cursor-pointer ' + actionIconsClass\"\n                aria-hidden=\"false\"\n                aria-label=\"info\"\n                inline=\"true\">keyboard_arrow_right\n              </mat-icon>\n            </div>\n          </mat-list-item>\n        </mat-list>\n      </div>\n\n      <wtc-shared-messages\n        [message]=\"msgText\"\n        [type]=\"msgType\"\n        class=\"text-center d-block mt-3 margin-auto\"></wtc-shared-messages>\n    </mat-tab>\n  </mat-tab-group>\n</div>\n"
            }]
    }], function () { return [{ type: ProfileService }, { type: ɵngcc6.MatDialog }, { type: ConfigShared }, { type: ɵngcc8.I18n }, { type: MessageService }, { type: ɵngcc13.Router }]; }, { actionIconsClass: [{
            type: Input
        }] }); })();

class MyPageSharedModule {
    static forRoot(environment) {
        return {
            ngModule: MyPageSharedModule,
            providers: [
                {
                    provide: 'env',
                    useValue: environment
                },
                DownloadFileService,
                BugsnagService,
                CookiesService,
                LoginService,
                GenericHttp,
                ProfileApiService,
                ProfileService,
                MessageService,
                TranslateService
            ]
        };
    }
}
MyPageSharedModule.ɵmod = ɵngcc0.ɵɵdefineNgModule({ type: MyPageSharedModule });
MyPageSharedModule.ɵinj = ɵngcc0.ɵɵdefineInjector({ factory: function MyPageSharedModule_Factory(t) { return new (t || MyPageSharedModule)(); }, imports: [[
            CommonModule,
            FormsModule,
            MatIconModule,
            MatSnackBarModule,
            NgxExtendedPdfViewerModule,
            ReactiveFormsModule,
            MatDialogModule,
            MatButtonModule,
            MatInputModule,
            MatButtonToggleModule,
            MatCheckboxModule,
            MatProgressSpinnerModule,
            MatTabsModule,
            MatInputModule,
            MatListModule,
            NgxExtendedPdfViewerModule
        ]] });
(function () { (typeof ngJitMode === "undefined" || ngJitMode) && ɵngcc0.ɵɵsetNgModuleScope(MyPageSharedModule, { declarations: function () { return [MyPageSharedComponent, HeaderComponent, MessagesComponent, PdfViewDialogComponent, AcceptOfferDialogComponent, DeclineOfferDialogComponent, OfferViewComponent, ProfileTabsComponent, OfferActionsComponent]; }, imports: function () { return [CommonModule,
        FormsModule,
        MatIconModule,
        MatSnackBarModule,
        NgxExtendedPdfViewerModule,
        ReactiveFormsModule,
        MatDialogModule,
        MatButtonModule,
        MatInputModule,
        MatButtonToggleModule,
        MatCheckboxModule,
        MatProgressSpinnerModule,
        MatTabsModule,
        MatInputModule,
        MatListModule,
        NgxExtendedPdfViewerModule]; }, exports: function () { return [MyPageSharedComponent, HeaderComponent, MessagesComponent, PdfViewDialogComponent, AcceptOfferDialogComponent, DeclineOfferDialogComponent, OfferViewComponent, ProfileTabsComponent, OfferActionsComponent]; } }); })();
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(MyPageSharedModule, [{
        type: NgModule,
        args: [{
                declarations: [
                    MyPageSharedComponent,
                    HeaderComponent,
                    MessagesComponent,
                    PdfViewDialogComponent,
                    AcceptOfferDialogComponent,
                    DeclineOfferDialogComponent,
                    OfferViewComponent,
                    ProfileTabsComponent,
                    OfferActionsComponent
                ],
                imports: [
                    CommonModule,
                    FormsModule,
                    MatIconModule,
                    MatSnackBarModule,
                    NgxExtendedPdfViewerModule,
                    ReactiveFormsModule,
                    MatDialogModule,
                    MatButtonModule,
                    MatInputModule,
                    MatButtonToggleModule,
                    MatCheckboxModule,
                    MatProgressSpinnerModule,
                    MatTabsModule,
                    MatInputModule,
                    MatListModule,
                    NgxExtendedPdfViewerModule
                ],
                exports: [
                    MyPageSharedComponent,
                    HeaderComponent,
                    MessagesComponent,
                    PdfViewDialogComponent,
                    AcceptOfferDialogComponent,
                    DeclineOfferDialogComponent,
                    OfferViewComponent,
                    ProfileTabsComponent,
                    OfferActionsComponent
                ],
                entryComponents: [
                    PdfViewDialogComponent,
                    AcceptOfferDialogComponent,
                    DeclineOfferDialogComponent
                ]
            }]
    }], null, null); })();

class AuthGuard extends KeycloakAuthGuard {
    constructor(config, router, keycloak) {
        super(router, keycloak);
        this.config = config;
        this.router = router;
        this.keycloak = keycloak;
    }
    isAccessAllowed(route, state) {
        return __awaiter(this, void 0, void 0, function* () {
            if (route.queryParams.brand) {
                this.config.updateBrandConfig(route.queryParams.brand);
            }
            // Force the user to log in if currently unauthenticated.
            if (!this.authenticated) {
                yield this.keycloak.login({
                    redirectUri: window.location.origin + state.url,
                });
            }
            // Get the roles required from the route.
            const requiredRoles = route.data.roles;
            // Allow the user to to proceed if no additional roles are required to access the route.
            if (!(requiredRoles instanceof Array) || requiredRoles.length === 0) {
                return true;
            }
            // Allow the user to proceed if all the required roles are present.
            return requiredRoles.every((role) => this.roles.includes(role));
        });
    }
}
AuthGuard.ɵfac = function AuthGuard_Factory(t) { return new (t || AuthGuard)(ɵngcc0.ɵɵinject(ConfigShared), ɵngcc0.ɵɵinject(ɵngcc13.Router), ɵngcc0.ɵɵinject(ɵngcc5.KeycloakService)); };
/** @nocollapse */ AuthGuard.ɵprov = ɵɵdefineInjectable({ factory: function AuthGuard_Factory() { return new AuthGuard(ɵɵinject(ConfigShared), ɵɵinject(Router), ɵɵinject(KeycloakService)); }, token: AuthGuard, providedIn: "root" });
/** @nocollapse */
AuthGuard.ctorParameters = () => [
    { type: ConfigShared },
    { type: Router },
    { type: KeycloakService }
];
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(AuthGuard, [{
        type: Injectable,
        args: [{
                providedIn: 'root'
            }]
    }], function () { return [{ type: ConfigShared }, { type: ɵngcc13.Router }, { type: ɵngcc5.KeycloakService }]; }, null); })();

class LoggedInGuard extends KeycloakAuthGuard {
    constructor(config, router, keycloak) {
        super(router, keycloak);
        this.config = config;
        this.router = router;
        this.keycloak = keycloak;
    }
    isAccessAllowed(route, state) {
        return __awaiter(this, void 0, void 0, function* () {
            let brand = state.url.replace('/', '');
            if (SUB_BRANDS_MAP[brand]) {
                this.config.updateBrandConfig(brand);
            }
            else if (route.queryParams.brand) {
                brand = route.queryParams.brand;
                this.config.updateBrandConfig(brand);
            }
            if (this.authenticated) {
                this.router.navigate([
                    this.config.pages.profile
                ], { queryParams: Object.assign({}, (brand.length && { brand })) });
            }
            return !this.authenticated;
        });
    }
}
LoggedInGuard.ɵfac = function LoggedInGuard_Factory(t) { return new (t || LoggedInGuard)(ɵngcc0.ɵɵinject(ConfigShared), ɵngcc0.ɵɵinject(ɵngcc13.Router), ɵngcc0.ɵɵinject(ɵngcc5.KeycloakService)); };
/** @nocollapse */ LoggedInGuard.ɵprov = ɵɵdefineInjectable({ factory: function LoggedInGuard_Factory() { return new LoggedInGuard(ɵɵinject(ConfigShared), ɵɵinject(Router), ɵɵinject(KeycloakService)); }, token: LoggedInGuard, providedIn: "root" });
/** @nocollapse */
LoggedInGuard.ctorParameters = () => [
    { type: ConfigShared },
    { type: Router },
    { type: KeycloakService }
];
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(LoggedInGuard, [{
        type: Injectable,
        args: [{
                providedIn: 'root'
            }]
    }], function () { return [{ type: ConfigShared }, { type: ɵngcc13.Router }, { type: ɵngcc5.KeycloakService }]; }, null); })();

/*
 * Public API Surface of wtc-shared
 */

/**
 * Generated bundle index. Do not edit.
 */

export { AcceptOfferDialogComponent, AuthGuard, BRANDS_CONFIG, BugsnagService, ConfigShared, CookiesService, DeclineOfferDialogComponent, DownloadFileService, GenericHttp, HeaderComponent, LoggedInGuard, LoginService, MessageService, MessagesComponent, MyPageSharedComponent, MyPageSharedModule, MyPageSharedService, OfferActionsComponent, OfferViewComponent, PdfViewDialogComponent, ProfileApiService, ProfileService, ProfileTabsComponent, SUB_BRANDS_CONFIG, SUB_BRANDS_MAP, TranslateService, UserStore };

//# sourceMappingURL=wtc-shared.js.map